import React from "react";

export default function ArrowRightICon() {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fal"
      data-icon="long-arrow-right"
      viewBox="0 0 448 512"
    >
      <path
        fill="currentColor"
        d="M311.03 131.515l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887l-83.928 83.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l116.485-116c4.686-4.686 4.686-12.284 0-16.971L328 131.515c-4.686-4.687-12.284-4.687-16.97 0z"
      />
    </svg>
  );
}

export const RightArrowIconAssistants = () => (
  <svg
    aria-hidden="true"
    data-prefix="fal"
    data-icon="long-arrow-right"
    viewBox="0 0 448 512"
  >
    <path
      fill="#F07F31"
      d="M311.03 131.515l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887l-83.928 83.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l116.485-116c4.686-4.686 4.686-12.284 0-16.971L328 131.515c-4.686-4.687-12.284-4.687-16.97 0z"
    />
  </svg>
);

export function FeatureArrowWithColor({ fillColor, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24.5 14"
      xmlSpace="preserve"
      className={className}
    >
      <path
        d="M24.5 7c0-.1 0-.2-.1-.3-.1-.1-.1-.2-.2-.3l-6-6c-.4-.4-1-.4-1.4 0-.2.2-.3.4-.3.7 0 .3.1.5.3.7L21.1 6H1c-.6 0-1 .5-1 1s.4 1 1 1h20.1l-4.3 4.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3l6-6c.2-.2.3-.4.3-.7z"
        fill={fillColor ? fillColor : "#2468f6"}
      />
    </svg>
  );
}

export function FeatureArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24.5 14"
      xmlSpace="preserve"
    >
      <path
        d="M24.5 7c0-.1 0-.2-.1-.3-.1-.1-.1-.2-.2-.3l-6-6c-.4-.4-1-.4-1.4 0-.2.2-.3.4-.3.7 0 .3.1.5.3.7L21.1 6H1c-.6 0-1 .5-1 1s.4 1 1 1h20.1l-4.3 4.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3l6-6c.2-.2.3-.4.3-.7z"
        fill="#2468f6"
      />
    </svg>
  );
}

export const DropdownArrow = () => (
  <svg viewBox="0 0 10 5.75" xmlns="http://www.w3.org/2000/svg">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M5,5.75H5a.78.78,0,0,1-.53-.21L.22,1.29a.74.74,0,0,1,0-1,.75.75,0,0,1,1,0L5,4,8.74.22a.74.74,0,0,1,1,1L5.51,5.54A.78.78,0,0,1,5,5.75Z"></path>
      </g>
    </g>
  </svg>
);

export const OpenIcon = () => {
  return (
    <svg viewBox="0 -53 384 384">
      <path d="M368 154.668H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0M368 32H16C7.168 32 0 24.832 0 16S7.168 0 16 0h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0M368 277.332H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0" />
    </svg>
  );
};
export const CloseIcon = () => {
  return (
    <svg x="0px" y="0px" viewBox="0 0 512.001 512.001" xmlSpace="preserve">
      <path d="M284.286 256.002L506.143 34.144c7.811-7.811 7.811-20.475 0-28.285-7.811-7.81-20.475-7.811-28.285 0L256 227.717 34.143 5.859c-7.811-7.811-20.475-7.811-28.285 0-7.81 7.811-7.811 20.475 0 28.285l221.857 221.857L5.858 477.859c-7.811 7.811-7.811 20.475 0 28.285a19.938 19.938 0 0014.143 5.857 19.94 19.94 0 0014.143-5.857L256 284.287l221.857 221.857c3.905 3.905 9.024 5.857 14.143 5.857s10.237-1.952 14.143-5.857c7.811-7.811 7.811-20.475 0-28.285L284.286 256.002z" />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="far"
      data-icon="search"
      viewBox="0 0 512 512"
      className="svg-inline--fa fa-search fa-w-16 fa-2x"
    >
      <path
        fill="currentColor"
        d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"
      />
    </svg>
  );
};

export const UpArrowIcon = (props) => (
  <svg viewBox="0 0 448 512" className="svg-inline--fa fa-chevron-up ">
    <path d="M6.101 359.293L25.9 379.092c4.686 4.686 12.284 4.686 16.971 0L224 198.393l181.13 180.698c4.686 4.686 12.284 4.686 16.971 0l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L232.485 132.908c-4.686-4.686-12.284-4.686-16.971 0L6.101 342.322c-4.687 4.687-4.687 12.285 0 16.971z" />
  </svg>
);

export function FaceBook(props) {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fab"
      data-icon="facebook-f"
      viewBox="0 0 320 512"
      className="svg-inline--fa fa-facebook-f fa-w-10 fa-2x"
    >
      <path
        fill="currentColor"
        d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
      />
    </svg>
  );
}
export function Twitter(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-prefix="fab"
      data-icon="twitter"
      className="svg-inline--fa fa-twitter fa-w-16 fa-2x"
      viewBox="0 0 19.5 18.3"
     
    >
      <g id="layer1" transform="translate(52.2 -25.9)">
        <path
           fill="currentColor"
          d="M-52.1,25.9-44.6,36l-7.6,8.2h1.7l6.6-7.2,5.4,7.2h5.8l-8-10.6,7.1-7.6h-1.7l-6.1,6.6L-46.3,26h-5.8Zm2.5,1.3h2.7l11.8,15.7h-2.7Z"
        />
      </g>
    </svg>
  );
}
export function Youtube(props) {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fab"
      data-icon="youtube"
      viewBox="0 0 576 512"
      className="svg-inline--fa fa-youtube fa-w-18 fa-2x"
    >
      <path
        fill="currentColor"
        d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
      />
    </svg>
  );
}
export function LinkedIn(props) {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fab"
      data-icon="linkedin-in"
      viewBox="0 0 448 512"
      className="svg-inline--fa fa-linkedin-in fa-w-14 fa-2x"
    >
      <path
        fill="currentColor"
        d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 01107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
      />
    </svg>
  );
}
export const InfoIcon = () => (
  <svg viewBox="0 0 512 512">
    <path
      fill="currentColor"
      d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    />
  </svg>
);

export const PricestadardIcon = () => (
  <svg
    id="Layer_3"
    data-name="Layer 3"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 143.07 114.21"
  >
    <path
      className="cls-1"
      d="M75.28,127.19H73.14a.54.54,0,0,1-.54-.54v-7.22c-.53-1.65-8.51-27-9.3-51.19L7.12,64.44a3.75,3.75,0,0,1-3.49-3.73V45.14a4.77,4.77,0,0,1,4.43-4.73l53.73-3.7A4.42,4.42,0,0,1,62,33.8a1.88,1.88,0,0,1,.58-.64,3.32,3.32,0,0,1-.25-2,2.16,2.16,0,0,1,1-1.56c0-1,.06-2.18.08-3.29,0-1.47,0-2.63.12-3.1l0-.15c.14-.91.49-3.32,3.3-3.42a.54.54,0,0,1,.56.52.54.54,0,0,1-.52.56c-1.77.06-2.1,1.32-2.27,2.5l0,.15c-.06.4-.08,1.64-.1,3s0,2.61-.11,3.64a.53.53,0,0,1-.35.48,1.11,1.11,0,0,0-.62.9A1.93,1.93,0,0,0,63.74,33a.53.53,0,0,1,.18.54.54.54,0,0,1-.4.4.83.83,0,0,0-.58.43A4.28,4.28,0,0,0,63,37a.56.56,0,0,1-.07.47.54.54,0,0,1-.41.23L8.13,41.48a3.68,3.68,0,0,0-3.42,3.66V60.71a2.68,2.68,0,0,0,2.48,2.66L63.86,67.2a.53.53,0,0,1,.5.52c.71,24.89,9.2,51.2,9.29,51.46a.47.47,0,0,1,0,.17v6.76h1.6a.54.54,0,1,1,0,1.08Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M71.68,123.54h0l-18.06-.22a5.09,5.09,0,0,1-5.08-5.08v-5.09a4.88,4.88,0,0,1,3.12-4.56l16.42-6.43a.54.54,0,1,1,.39,1L52,109.59a3.8,3.8,0,0,0-2.43,3.56v5.09a4,4,0,0,0,4,4l17.68.21.83-2.28a.55.55,0,0,1,.69-.33.54.54,0,0,1,.32.69l-1,2.65A.55.55,0,0,1,71.68,123.54Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M56.16,20.7a1.94,1.94,0,0,1-1.27-.44,1.35,1.35,0,0,1-.41-1V17.64a1.61,1.61,0,0,1,1.72-1.47H70.39l-.06-.66a.51.51,0,0,1,.13-.41.53.53,0,0,1,.4-.18h1.67V13.51a.54.54,0,0,1,.54-.54h2.21a.54.54,0,0,1,.54.54.54.54,0,0,1-.54.54H73.6v1.41a.54.54,0,0,1-.53.54H71.46l.07.65a.57.57,0,0,1-.14.42.54.54,0,0,1-.4.18H56.23s-.67.05-.67.39v1.61a.27.27,0,0,0,.07.22,1,1,0,0,0,.57.15H72.81a.54.54,0,1,1,0,1.08H56.16Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M29.32,65l-.53,0s.21-3,.37-5.08a3.41,3.41,0,0,0-.83-2.62,2.85,2.85,0,0,0-2.15-.9c-2.1,0-11.35-.16-14.06-.26a3.51,3.51,0,0,0-2.61.7,2.27,2.27,0,0,0-.62,1.69V64a.27.27,0,0,1-.54,0V58.51a2.8,2.8,0,0,1,.79-2.08,4,4,0,0,1,3-.85c2.71.1,11.94.26,14,.26a3.46,3.46,0,0,1,2.55,1.08,3.94,3.94,0,0,1,1,3C29.54,62,29.32,65,29.32,65Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M6,50.05a.27.27,0,0,1-.27-.27v-3.4c0-.62.34-2.63,4.77-2.93,3.89-.27,44-2.8,44.43-2.82a.26.26,0,0,1,.29.25.27.27,0,0,1-.26.28c-.4,0-40.53,2.56-44.42,2.82-3.15.22-4.28,1.38-4.28,2.4v3.4A.27.27,0,0,1,6,50.05Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M57.45,64.79H57.2c-1.64,0-10.65-.63-17.92-1.13a.27.27,0,0,1-.25-.29.29.29,0,0,1,.29-.25c7.26.5,16.26,1.1,17.89,1.13a4,4,0,0,0,2.63-.57,2.91,2.91,0,0,0,.87-2.41c0-2.57-.37-10-.37-10.09a.26.26,0,0,1,.25-.28h0a.27.27,0,0,1,.27.25c0,.07.42,7.54.37,10.13a3.46,3.46,0,0,1-1.07,2.83A4.28,4.28,0,0,1,57.45,64.79Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M37.08,63.51h0l-2.22-.16a.27.27,0,0,1,0-.53L37.1,63a.28.28,0,0,1,.25.29A.27.27,0,0,1,37.08,63.51Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M56.35,110.23a.26.26,0,0,1-.25-.19.27.27,0,0,1,.17-.34l10.53-3.45a.27.27,0,1,1,.17.51l-10.53,3.46Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M60.85,122.47a.27.27,0,0,1-.26-.27v-4.47a.27.27,0,1,1,.53,0v4.47A.27.27,0,0,1,60.85,122.47Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M67.84,122.78"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M67.84,123.05a.27.27,0,0,1-.26-.27v-4.36a.27.27,0,1,1,.53,0v4.36A.27.27,0,0,1,67.84,123.05Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M63.53,66.74a.54.54,0,0,1-.53-.51c0-.2-1.36-20.67-1.28-28.53a.49.49,0,0,1,.55-.53.52.52,0,0,1,.53.54c-.08,7.82,1.26,28.25,1.27,28.45a.53.53,0,0,1-.5.57Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M62.79,20.18a.27.27,0,0,1-.27-.27V17.44a.27.27,0,1,1,.54,0v2.47A.27.27,0,0,1,62.79,20.18Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M68.2,20.43a.27.27,0,0,1-.27-.27V17.07a.27.27,0,0,1,.54,0v3.09A.27.27,0,0,1,68.2,20.43Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M77.2,127.19H75.05a.54.54,0,0,1,0-1.08h1.61v-6.76a.88.88,0,0,1,0-.17c.09-.26,8.58-26.57,9.29-51.46a.54.54,0,0,1,.5-.52l56.67-3.83a2.68,2.68,0,0,0,2.48-2.66V45.14a3.68,3.68,0,0,0-3.42-3.66L87.83,37.74a.54.54,0,0,1-.41-.23.56.56,0,0,1-.07-.47,4.22,4.22,0,0,0,0-2.71.81.81,0,0,0-.58-.43.56.56,0,0,1-.4-.4.57.57,0,0,1,.18-.54A2,2,0,0,0,87,31.33a1.13,1.13,0,0,0-.62-.9A.53.53,0,0,1,86,30c-.06-1-.09-2.4-.11-3.64s0-2.56-.1-3l0-.15c-.18-1.18-.51-2.44-2.27-2.5a.54.54,0,0,1-.52-.56.56.56,0,0,1,.55-.52c2.81.1,3.17,2.51,3.3,3.42l0,.15a30.66,30.66,0,0,1,.12,3.1c0,1.11,0,2.31.09,3.29a2.22,2.22,0,0,1,1,1.56,3.48,3.48,0,0,1-.25,2,1.86,1.86,0,0,1,.57.64,4.49,4.49,0,0,1,.22,2.91l53.73,3.7a4.76,4.76,0,0,1,4.42,4.73V60.71a3.75,3.75,0,0,1-3.49,3.73L87,68.24c-.78,24.2-8.77,49.54-9.3,51.19v7.22A.54.54,0,0,1,77.2,127.19Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M78.66,123.54a.55.55,0,0,1-.51-.36l-1-2.65a.54.54,0,0,1,.32-.69.55.55,0,0,1,.69.33l.83,2.28,17.68-.21a4,4,0,0,0,4-4v-5.09a3.8,3.8,0,0,0-2.43-3.56l-16.42-6.43a.54.54,0,1,1,.39-1l16.43,6.43a4.87,4.87,0,0,1,3.11,4.56v5.09a5.09,5.09,0,0,1-5.08,5.08l-18.06.22Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M94.16,20.7H77.53a.54.54,0,1,1,0-1.08H94.1a.93.93,0,0,0,.6-.15.26.26,0,0,0,.08-.22V17.64c0-.34-.69-.39-.7-.39H79.34a.55.55,0,0,1-.4-.18.57.57,0,0,1-.14-.42l.07-.65h-1.6a.54.54,0,0,1-.54-.54V14.05H75.05a.54.54,0,0,1-.54-.54.54.54,0,0,1,.54-.54h2.22a.54.54,0,0,1,.54.54v1.41h1.66a.52.52,0,0,1,.4.18.51.51,0,0,1,.13.41l-.06.66H94.11c.85,0,1.74.51,1.74,1.47v1.61a1.35,1.35,0,0,1-.41,1A1.94,1.94,0,0,1,94.16,20.7Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M121,65s-.21-3-.37-5.08a3.9,3.9,0,0,1,1-3,3.42,3.42,0,0,1,2.54-1.08c2.1,0,11.34-.16,14-.26a3.93,3.93,0,0,1,3,.85,2.8,2.8,0,0,1,.79,2.08V64a.27.27,0,0,1-.27.27.28.28,0,0,1-.27-.27V58.51a2.27,2.27,0,0,0-.62-1.69,3.49,3.49,0,0,0-2.61-.7c-2.71.1-12,.26-14.06.26a2.85,2.85,0,0,0-2.15.9,3.45,3.45,0,0,0-.83,2.62c.16,2.1.38,5.08.38,5.08Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M89.48,122.47a.27.27,0,0,1-.27-.27v-4.47a.27.27,0,0,1,.54,0v4.47A.27.27,0,0,1,89.48,122.47Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M82.49,122.78"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M82.49,123.05a.27.27,0,0,1-.27-.27v-4.36a.27.27,0,1,1,.54,0v4.36A.27.27,0,0,1,82.49,123.05Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M86.8,67.75h0a.54.54,0,0,1-.51-.57c0-.22,1.27-21.65,1.18-29.47a.53.53,0,0,1,.53-.54.56.56,0,0,1,.55.53c.08,7.86-1.17,29.33-1.18,29.54A.55.55,0,0,1,86.8,67.75Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M87.54,20.18a.27.27,0,0,1-.27-.27V17.44a.27.27,0,0,1,.54,0v2.47A.27.27,0,0,1,87.54,20.18Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M82.13,20.43a.28.28,0,0,1-.27-.27V17.07a.27.27,0,0,1,.27-.26.27.27,0,0,1,.27.26v3.09A.27.27,0,0,1,82.13,20.43Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M71.49,20.43a.27.27,0,0,1-.27-.25c0-.56-.14-3.33,1.11-3.6a.25.25,0,0,1,.22.05C74,17.75,74,17.75,75.28,17.75c.73.13,1,.05,2.5-1.12a.25.25,0,0,1,.22-.05c1.26.27,1.15,3,1.11,3.6a.27.27,0,0,1-.27.25h0a.27.27,0,0,1-.25-.28c.06-1.12-.08-2.71-.59-3-1.42,1.09-1.83,1.31-2.75,1.15-1.37,0-1.44,0-2.9-1.15-.51.3-.65,1.89-.58,3a.28.28,0,0,1-.26.28Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M74.18,24.14a42.22,42.22,0,0,1-7.46-.61.27.27,0,0,1-.21-.31.28.28,0,0,1,.32-.22,44.63,44.63,0,0,0,16.42-.35.27.27,0,0,1,.32.21.28.28,0,0,1-.2.32A42.94,42.94,0,0,1,74.18,24.14Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M74.71,31A26.64,26.64,0,0,1,66.43,30a.26.26,0,0,1-.16-.34.27.27,0,0,1,.34-.16c.07,0,6.62,2.32,17.55,0a.25.25,0,0,1,.32.2.27.27,0,0,1-.2.32A46.06,46.06,0,0,1,74.71,31Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75,34.84a36.66,36.66,0,0,1-9-1,.27.27,0,0,1,.15-.52,38.87,38.87,0,0,0,17.61,0,.27.27,0,0,1,.13.53A38.83,38.83,0,0,1,75,34.84Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M74.65,38.66A31.32,31.32,0,0,1,66,37.57a.26.26,0,0,1-.17-.34.28.28,0,0,1,.34-.17,34.45,34.45,0,0,0,18.25-.31.27.27,0,0,1,.15.52A36.06,36.06,0,0,1,74.65,38.66Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M74.63,85.45a38.43,38.43,0,0,1-6.53-.56.27.27,0,0,1-.22-.31.28.28,0,0,1,.31-.22c.08,0,8.11,1.49,13.71-.49a.26.26,0,0,1,.34.16.26.26,0,0,1-.16.34A22.91,22.91,0,0,1,74.63,85.45Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75.05,88.18a31.51,31.51,0,0,1-7-.71.27.27,0,0,1-.2-.32.28.28,0,0,1,.33-.2,33.5,33.5,0,0,0,13.52,0,.27.27,0,0,1,.11.53A32.49,32.49,0,0,1,75.05,88.18Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75.8,72.73a8.19,8.19,0,0,1-8.18-8.18V51.62a8.18,8.18,0,0,1,16.36,0V64.55A8.19,8.19,0,0,1,75.8,72.73ZM75.8,44a7.65,7.65,0,0,0-7.64,7.65V64.55a7.64,7.64,0,0,0,15.28,0V51.62A7.65,7.65,0,0,0,75.8,44Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75.7,57.72a26.11,26.11,0,0,1-7.9-1.29.26.26,0,0,1-.16-.34.26.26,0,0,1,.34-.16c.09,0,9.27,3.15,15.34-.69a.28.28,0,0,1,.37.09.27.27,0,0,1-.09.37A14.71,14.71,0,0,1,75.7,57.72Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75.62,66.76a25.63,25.63,0,0,1-7.78-1.19.27.27,0,0,1-.16-.35.26.26,0,0,1,.34-.16c.08,0,8,2.8,15.33-.31a.27.27,0,1,1,.21.5A20.49,20.49,0,0,1,75.62,66.76Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75.8,72.42a.27.27,0,0,1-.27-.27V66.83a.27.27,0,0,1,.54,0v5.32A.27.27,0,0,1,75.8,72.42Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M90.31,54.36h0a.28.28,0,0,1-.27-.28c0-.08.2-8.09.29-9.87.12-2.09,1-3.42,5-3.58.44,0,40.57,2.55,44.46,2.82a.26.26,0,0,1,.25.28c0,.15-.14.3-.28.25-3.9-.26-44-2.79-44.43-2.82-4,.17-4.39,1.49-4.48,3.08-.09,1.77-.29,9.77-.29,9.85A.27.27,0,0,1,90.31,54.36Z"
      transform="translate(-3.63 -12.97)"
    ></path>
  </svg>
);
export const PriceBasicIcon = () => (
  <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 91 125.1" xmlSpace="preserve">
    <g id="basic" transform="translate(-914.238 -477.587)">
      <path
        className="st0"
        d="M949.5 532.2c-.3 0-.6-.2-.7-.4-1.3-2.9-2.5-5.5-2.5-5.5-2.3-5.5-3.6-11.3-3.6-17.3 0-.4.3-.8.7-.8.4 0 .8.3.8.7 0 5.8 1.2 11.4 3.5 16.7 0 0 1.2 2.6 2.5 5.5.2.4 0 .8-.4 1-.1.1-.2.1-.3.1z"
        id="Path_4101"
      />
      <path
        className="st0"
        d="M943.6 504.9c-.5 0-.8-.4-.7-.8 1.1-14.7 8.5-25.8 17.1-25.8 8.6 0 15.9 11 17.1 25.6 0 .4-.3.8-.7.8-.4 0-.8-.3-.8-.7-1.1-13.8-7.8-24.2-15.6-24.2s-14.5 10.5-15.6 24.4c-.1.4-.4.7-.8.7z"
        id="Path_4102"
      />
      <path
        className="st0"
        d="M970.3 531.9c-.1 0-.2 0-.3-.1-.4-.2-.5-.6-.4-1 1.2-2.6 2.3-4.9 2.3-4.9 2.4-5.2 3.6-10.8 3.8-16.5 0-.4.3-.7.8-.7.4 0 .7.4.7.8-.1 5.9-1.4 11.7-3.9 17.1 0 0-1.1 2.3-2.3 4.9-.2.2-.5.4-.7.4z"
        id="Path_4103"
      />
      <path
        className="st0"
        d="M959.7 602.7c-3.4 0-3.6-2.6-3.7-4-.1-1.3-.5-6.2-.6-8.1h-14.9c-.4 0-.8-.3-.8-.8v-7.6c0-.4.3-.8.8-.8h14.7c-.2-4.7-1.3-28.7-1.5-32.8-.2-3.8-1-7.6-2.4-11.1-.3-.7-.7-1.7-1.2-2.8-.2-.4 0-.8.4-1 .4-.2.8 0 1 .4.5 1.1.9 2.1 1.2 2.8 1.5 3.7 2.4 7.6 2.5 11.6l1.5 33.6c0 .2-.1.4-.2.6-.1.1-.3.2-.5.2h-14.7v6.1h14.9c.4 0 .7.3.7.7 0 0 .5 7.2.7 8.8.1 1.7.4 2.5 2.2 2.5s2.1-.8 2.2-2.5c.1-1.6.7-8.8.7-8.8 0-.4.4-.7.7-.7h14.8v-6.1h-14.7c-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.6 0 0 1.3-29 1.5-33.6.2-4 1-7.9 2.5-11.6.3-.7.7-1.7 1.2-2.8.2-.4.6-.5 1-.4.4.2.5.6.4 1-.5 1.1-.9 2.1-1.2 2.8-1.5 3.5-2.3 7.3-2.4 11.1-.2 4.1-1.3 28.1-1.5 32.8H979c.4 0 .8.3.8.8v7.6c0 .4-.3.8-.8.8h-15c-.1 1.8-.5 6.8-.6 8.1-.1 1.4-.2 4-3.7 4z"
        id="Path_4104"
      />
      <path
        className="st0"
        d="M947.4 498.9c-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.3 1.7-9.9 6.9-16.5 12.9-16.5 5.9 0 11.1 6.6 12.9 16.5 0 .1 0 .2-.1.3s-.2.1-.3.1h-25zm12.5-16.3c-5.4 0-10.4 6.4-12.1 15.5H972c-1.7-9.1-6.6-15.5-12.1-15.5z"
        id="Path_4105"
      />
      <path
        className="st0"
        d="M918.1 568.7h-.2c-1-.5-1.5-1.3-1.7-2.4-.2-1.7.6-3.6 1.6-4.5 1.5-1.4 35.7-34.4 38.5-37.1-.4-1-.4-2.1 0-3l-42.1-40.4c-.1-.1-.1-.3 0-.5.8-.9 1.8-1.4 2.9-1.5 1.6 0 3.6 1 5.2 2.7 1.9 2 33.3 35 35.9 37.7.9-.4 1.8-.4 2.7-.1l40.5-41.9c.1-.1.3-.1.5 0 .1.1 1.8 1.5 1.9 3.5.1 1.2-.4 2.3-1.5 3.3-3.2 3.1-36.4 34.9-39.1 37.4.3.8.3 1.7 0 2.6l41.8 40.2c.1.1.1.2.1.3-.1.8-.8 1.5-1.7 1.8-.8.3-3.1.6-5.9-2.2-3.5-3.4-33.9-35.3-36.4-38-.9.3-1.8.3-2.7 0l-40.1 42c0 .1-.1.1-.2.1zm-3-87.8l42 40.3c.1.1.1.3.1.4-.5.9-.5 2 0 2.9.1.1 0 .3-.1.4-.4.4-37.1 35.8-38.7 37.3-1 .9-1.6 2.6-1.4 3.9.1.8.5 1.4 1.1 1.8l40.1-41.9c.1-.1.3-.1.4-.1.8.4 1.7.4 2.6 0 .1-.1.3 0 .4.1.3.3 33 34.6 36.6 38.1 1.8 1.7 3.7 2.5 5.2 2 .6-.2 1.1-.6 1.2-1.1l-41.8-40.3c-.1-.1-.1-.3-.1-.4.3-.8.4-1.7 0-2.5-.1-.1 0-.3.1-.4.4-.3 35.9-34.4 39.2-37.6.9-.9 1.3-1.8 1.3-2.8-.1-1.3-1-2.3-1.4-2.7l-40.4 41.8c-.1.1-.3.1-.4.1-.8-.3-1.8-.3-2.6.1-.1.1-.3 0-.4-.1 0 0-34.2-35.9-36.1-37.9-1.5-1.6-3.3-2.5-4.7-2.4-.9 0-1.6.4-2.2 1z"
        id="Path_4106"
      />
      <path
        className="st0"
        d="M956.1 588.8c-.2 0-.3-.2-.4-.3l-.1-4.3c0-.2.1-.4.3-.4.2 0 .4.1.4.3l.1 4.3c.1.2-.1.4-.3.4z"
        id="Line_329"
      />
      <path
        className="st0"
        d="M963.5 588.7c-.2 0-.4-.2-.3-.4v-4.7c0-.2.2-.3.3-.3.2 0 .3.2.3.4v4.7c.1.1-.1.3-.3.3z"
        id="Line_330"
      />
    </g>
  </svg>
);

export const YesIcon = () => (
  <svg
    viewBox="0 0 448 512"
    className="svg-inline--fa fa-check fa-w-14 fa-2x support_correct_svg"
    version="1.1"
  >
    <path d="M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z"></path>
  </svg>
);
export const NoIcon = () => (
  <svg
    viewBox="0 0 320 512"
    className="svg-inline--fa fa-times fa-w-10 fa-2x support_error_svg"
    version="1.1"
  >
    <path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path>
  </svg>
);
export const PricingYesIcon = () => (
  <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve" fill="#466AF3">
    <path d="M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zm0-30C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2z" />
    <path d="M14.1 22c-.2 0-.5-.1-.6-.2l-6.1-5.2c-.4-.4-.5-1-.1-1.4.4-.4 1-.5 1.4-.1l5.4 4.6 9.3-9.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-9.9 10c-.3.1-.6.2-.8.2z" />
  </svg>
);

export const PricingNoIcon = () => (
  <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve" fill="#E05959">
    <path d="M4.7 27.3c-3-3-4.7-7-4.7-11.3 0-4.3 1.7-8.3 4.7-11.3S11.7 0 16 0c4.3 0 8.3 1.7 11.3 4.7S32 11.7 32 16c0 4.3-1.7 8.3-4.7 11.3S20.3 32 16 32c-4.3 0-8.3-1.7-11.3-4.7zM25.9 6.1C23.3 3.5 19.7 2 16 2S8.7 3.5 6.1 6.1C3.5 8.7 2 12.3 2 16s1.5 7.3 4.1 9.9C8.7 28.5 12.3 30 16 30s7.3-1.5 9.9-4.1c2.6-2.6 4.1-6.2 4.1-9.9s-1.5-7.3-4.1-9.9z" />
    <path d="M20.2 21.7l-9.9-9.9c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l9.9 9.9c.4.4.4 1 0 1.4s-1 .3-1.4 0z" />
    <path d="M10.3 21.7c-.4-.4-.4-1 0-1.4l9.9-9.9c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-9.9 9.9c-.3.3-1 .3-1.4 0z" />
  </svg>
);
export const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.24 16.24">
    <p>Add</p>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M0,8.12a.93.93,0,0,1,.93-.93H7.19V.93a.93.93,0,0,1,1.86,0V7.19h6.26a.93.93,0,0,1,0,1.86H9.05v6.26a.93.93,0,0,1-1.86,0V9.05H.93A.93.93,0,0,1,0,8.12Z"></path>
      </g>
    </g>
  </svg>
);

export const Mob_Automate_Icon = () => (
  <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 40 40" xmlSpace="preserve">
    <style>{".st1a{fill:#09a86c}"}</style>
    <g id="workativ_automate" transform="translate(-72 -371)">
      <g id="workativ_automate-2" transform="translate(72 371)">
        <path
          id="Rectangle_1525"
          d="M4 0h32c2.2 0 4 1.8 4 4v32c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z"
          fill="#ceffec"
        />
      </g>
      <g id="why_icon_2" transform="translate(77.519 381.319)">
        <path
          className="st1a"
          d="M18.2 5.3h-7.1c-.3 0-.5-.2-.5-.5V0c0-.3.2-.5.5-.5h7.1c.3 0 .5.2.5.5v4.8c0 .3-.2.5-.5.5zm-6.6-1h6.1V.5h-6.1v3.8z"
          id="Rectangle_37"
        />
        <path
          className="st1a"
          d="M7.1 4.9H0c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h7.1c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5zm-6.6-1h6.1v-3H.5v3z"
          id="Rectangle_760"
        />
        <path
          className="st1a"
          d="M29.1 5.3H22c-.3 0-.5-.2-.5-.5V0c0-.3.2-.5.5-.5h7.1c.3 0 .5.2.5.5v4.8c0 .3-.2.5-.5.5zm-6.6-1h6.1V.5h-6.1v3.8z"
          id="Rectangle_761"
        />
        <path
          className="st1a"
          d="M14.6 12.8c-.3 0-.5-.2-.5-.5V5.2c0-.3.2-.5.5-.5s.5.2.5.5v7.1c0 .2-.2.5-.5.5z"
          id="Line_23"
        />
        <path
          className="st1a"
          d="M10.9 3.2H7.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.5c.3 0 .5.2.5.5s-.2.5-.4.5z"
          id="Line_220"
        />
        <path
          className="st1a"
          d="M21.9 3.2h-3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.5c.3 0 .5.2.5.5s-.2.5-.5.5z"
          id="Line_221"
        />
        <path
          className="st1a"
          d="M18.3 20.3h-7.1c-.3 0-.5-.2-.5-.5v-7.1c0-.3.2-.5.5-.5h7.1c.3 0 .5.2.5.5v7.1c0 .3-.2.5-.5.5zm-6.6-1h6.1v-6.1h-6.1v6.1z"
          id="Rectangle_39"
        />
        <g id="Group_2003" transform="translate(12.748 14.974)">
          <g id="Path_1728">
            <path
              className="st1a"
              d="M1.7 3h-.1L.1 1.4c-.1 0-.1-.1 0-.2s.2-.1.2 0l1.4 1.4L4 .1c.1-.1.2-.1.3-.1.1.1.1.2 0 .2L1.8 2.9c0 .1-.1.1-.1.1z"
            />
            <path
              className="st1a"
              d="M1.7 3.2c-.1 0-.2-.1-.3-.1L-.1 1.6c-.2-.2-.2-.4 0-.6C0 .9.3.9.5 1l1.2 1.2L3.9-.1c0-.1.1-.1.2-.2.1 0 .2 0 .3.1.2.2.2.4.1.6L2 3.1c-.1.1-.2.1-.3.1zm2.5-3z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const Mob_Assistant_Icon = () => (
  <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 40 40" xmlSpace="preserve">
    <style>{".st1t{fill:#466af3}"}</style>
    <g id="workativ_assistant" transform="translate(-888 -62)">
      <path
        id="Rectangle_1526"
        d="M892 62h32c2.2 0 4 1.8 4 4v32c0 2.2-1.8 4-4 4h-32c-2.2 0-4-1.8-4-4V66c0-2.2 1.8-4 4-4z"
        fill="#e5eaff"
      />
      <g id="Group_8120" transform="translate(895.602 80.793)">
        <g id="Group_5258">
          <g id="Group_2074">
            <path
              className="st1t"
              d="M.9 16c-.5 0-1.1-.3-1.3-.9 0-.1-.1-.2-.1-.3 0-.6 0-1.1.1-1.6.2-.9.8-1.6 1.6-1.9.5-.2 1-.4 1.6-.6l1-.3c.5-.2.8 0 1 .5l.8 2.2c.1-.2.2-.4.3-.5-.4-.3-.5-.8-.5-1.2 0-.4.2-.9.6-1.1.1 0 .2-.1.3-.1h-.1c-1.4-.6-2.4-1.7-2.8-3.1-.3-.1-.7-.4-.8-.8-.2-.5-.3-1-.3-1.6 0-.4.2-.8.6-.9 0-.6 0-1.2.1-1.7.2-1.2 1.3-2 2.5-2 .3-.3.5-.5.8-.5.6-.1 1.2 0 1.7.1 1 .2 1.9.8 2.5 1.6.4.6.7 1.4.6 2.1l-.5-.1.5.1v.3c.5.3.7.6.6 1.3-.1.5-.2.9-.3 1.4-.1.4-.5.7-.9.8-.4 1.4-1.4 2.5-2.7 3.1.1 0 .2.1.2.1.5.2.7.7.6 1.3-.1.4-.2.8-.5 1.1.1.2.2.4.3.5l.6-1.4.3-.9c.1-.2.2-.4.4-.5.1-.1.3-.1.6 0l.8.3 1.5.6c.8.3 1.5.9 1.8 1.7.2.6.2 1.2.1 1.8-.1.6-.6 1.1-1.3 1.1H1.1.9zm3-4.5l-.8.3-1.5.6c-.5.2-.9.6-1 1.1-.1.4-.1.9-.1 1.3.1.1.3.3.5.2h4.2l-.3-.6c0-.1-.1-.1-.1-.2l-.9-2.7zM7 11c-.2 0-.5.1-.6.2-.1 0-.1.1-.1.1 0 .3.1.5.3.6.1.1.2.2.3.4s0 .4-.1.6l-.1.1c-.1.2-.3.6-.5.9l-.2.5s-.1.1-.1.2l-.4.4h2.9l-.4-.8c-.3-.5-.5-.9-.8-1.3-.2-.3 0-.7.2-.9.2-.2.3-.4.4-.7 0-.1 0-.2-.1-.2-.2 0-.4-.1-.7-.1zm3.2.5c-.1.2-.2.5-.2.7L9 15h4.3c.2 0 .3-.1.3-.3.1-.5 0-.9-.1-1.4-.2-.5-.6-.9-1.1-1.1l-1.5-.6-.7-.1zM6 12.8zm2.1-.4zM5.4 1.1c-.6 0-1.2.5-1.4 1.2-.1.5-.1 1.1-.1 1.6 0 .4-.2.7-.6.8 0 .4 0 .8.2 1.2l.3.3c.3.1.5.3.6.6.3 1.2 1.1 2.1 2.2 2.5.3.2.6.2.9 0 1.1-.4 1.9-1.4 2.2-2.5.1-.5.5-.6.8-.7l.1-.1.3-1.2v-.1s-.1 0-.2-.1c-.1 0-.3-.1-.4-.3-.1-.1-.2-.3-.1-.5v-.1-.4h.5-.5c0-.5-.1-1-.4-1.5-.5-.5-1.2-1-2-1.1C7.3.5 6.9.5 6.5.5c-.2.4-.6.6-1.1.6.1 0 .1 0 0 0zm5.4 2.6s.1 0 0 0c.1 0 0 0 0 0z"
              id="Path_1711"
            />
            <path
              className="st1t"
              d="M7 10.4c-.3 0-.6-.1-.9-.2-1.3-.6-2.3-1.7-2.6-3.1-.4-.1-.7-.4-.9-.8-.2-.5-.3-1-.3-1.6 0-.4.2-.8.6-.9 0-.6 0-1.1.1-1.7.2-1.2 1.3-2 2.5-2 .3-.3.5-.5.8-.5.6-.1 1.2 0 1.7.1 1 .2 1.9.8 2.5 1.6.4.6.7 1.4.6 2.1v.4c.5.2.7.5.7 1.2-.1.5-.2 1-.3 1.4-.1.4-.5.7-.9.8-.4 1.4-1.4 2.6-2.8 3.1-.2 0-.5.1-.8.1zM3.2 4.7c.1.4.1.8.3 1.2l.3.3c.3.1.5.3.6.6.3 1.2 1.1 2.1 2.2 2.6.3.2.6.2.9 0C8.6 9 9.4 8 9.7 6.9c.1-.5.5-.6.8-.7l.1-.1.3-1.2v-.1s-.1 0-.2-.1c-.4-.1-.6-.5-.5-.9v-.4c0-.5-.1-1-.4-1.5-.5-.6-1.2-1.1-2-1.2C7.4.5 6.9.5 6.5.5c-.1.3-.5.6-1 .6-.7 0-1.3.5-1.5 1.2-.1.5-.1 1.1-.1 1.6 0 .6-.4.8-.6.8h-.1zm7.9-.7s0 .1 0 0c0 .1 0 .1 0 0z"
              id="Path_1712"
            />
            <path
              className="st1t"
              d="M.9 16c-.5 0-1.1-.3-1.3-.9 0-.1-.1-.2-.1-.3 0-.6 0-1.1.1-1.6.2-.9.8-1.6 1.6-1.9.5-.2 1-.4 1.4-.5l1.1-.4c.5-.2.8 0 1 .5l.8 2.2c.1-.2.2-.4.3-.5-.3-.3-.5-.8-.5-1.2 0-.4.2-.9.6-1.1.7-.4 1.5-.4 2.2 0 .5.2.7.7.6 1.3-.1.4-.2.8-.5 1.1.1.2.2.4.3.5l.8-2.3c.1-.2.2-.4.4-.4.1-.1.3-.1.6 0l.8.3 1.5.6c.8.3 1.5.9 1.8 1.7.2.6.2 1.2.1 1.8-.1.6-.6 1.1-1.3 1.1H1.1.9zm3-4.5l-.9.3c-.5.2-1 .3-1.4.5-.5.2-.9.6-1 1.1-.1.4-.1.9-.1 1.3.1.2.3.4.5.3h4.2l-.2-.5.5-.2-.5.1c0-.1-.1-.1-.1-.2l-1-2.7zM7 11c-.2 0-.5.1-.6.2-.1 0-.1.1-.1.1 0 .3.1.5.3.6.2.2.3.4.3.6 0 .2 0 .4-.2.5-.1.2-.3.5-.5.8l-.2.6c0 .1-.1.1-.1.2l-.4.4h2.9l-.4-.7c-.3-.5-.5-.9-.8-1.3-.2-.3 0-.7.2-.9.2-.2.3-.4.4-.6 0-.1 0-.2-.1-.2-.2-.2-.4-.3-.7-.3zm3.2.5L8.9 15h4.3c.2 0 .3-.1.3-.3.1-.5 0-.9-.1-1.4-.2-.5-.6-.9-1.1-1.1l-1.5-.6-.6-.1z"
              id="Path_1713"
            />
          </g>
        </g>
      </g>
      <g id="Group_8115" transform="translate(904.816 67.788)">
        <path
          className="st1t"
          d="M7.7 3.2h-5c-.2 0-.5-.2-.5-.5s.2-.5.5-.5h4.9c.3 0 .5.2.5.5s-.2.5-.4.5z"
          id="Line_327"
        />
        <path
          className="st1t"
          d="M6.3 5.4H2.7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.5c.3 0 .5.2.5.5s-.1.5-.4.5z"
          id="Line_328"
        />
        <g id="Group_8114">
          <g id="Group_8110">
            <g id="Group_8109">
              <g id="Group_8108">
                <path
                  className="st1t"
                  d="M9.5 8.2H1.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7.7c.2 0 .3-.1.4-.2s.1-.2.1-.4V1.1c0-.3-.3-.6-.6-.6H1.1C.8.5.5.8.5 1.1v6.6c0 .3-.2.5-.5.5s-.5-.2-.5-.5V1.1C-.5.2.2-.5 1.1-.5h8.4c.9 0 1.6.7 1.6 1.6v5.6c0 .4-.2.8-.5 1.1-.3.2-.7.4-1.1.4z"
                  id="Path_4340"
                />
              </g>
              <path
                className="st1t"
                d="M0 11h-.1c-.2-.1-.4-.3-.4-.5V7.7c0-.3.2-.5.5-.5s.5.2.5.5v1.1l.9-1.4c.1-.2.5-.3.7-.2.2.2.3.5.1.8L.4 10.8c-.1.1-.2.2-.4.2z"
                id="Path_4341"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Group_8125" transform="translate(910.015 77.225)">
        <g id="Group_8124" transform="translate(.843 1.961)">
          <path
            className="st1t"
            d="M3.9 3.4c-.3 0-.5-.2-.5-.5V0c0-.3.2-.5.5-.5s.5.2.5.5v2.9c0 .2-.2.5-.5.5z"
            id="Line_330"
          />
          <path
            className="st1t"
            d="M3.9 5.4c-.3 0-.5-.2-.5-.5V2.2c0-.3.2-.5.5-.5s.5.2.5.5v2.7c0 .3-.2.5-.5.5z"
            id="Line_331"
          />
          <path
            className="st1t"
            d="M7.8 5.3c-.3 0-.5-.2-.5-.5V2.3c0-.3.2-.5.5-.5s.5.2.5.5v2.4c0 .4-.3.6-.5.6z"
            id="Line_332"
          />
          <path
            className="st1t"
            d="M0 5.3c-.3 0-.5-.2-.5-.5V2.3c0-.3.2-.5.5-.5s.5.2.5.5v2.4c0 .4-.2.6-.5.6z"
            id="Line_333"
          />
          <path
            className="st1t"
            d="M7.7 2.8H.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7.6c.3 0 .5.2.5.5s-.2.5-.5.5z"
            id="Line_334"
          />
        </g>
        <path
          className="st1t"
          d="M7.3 2.2H2.2C1.4 2.2.8 1.6.8.8S1.4-.6 2.2-.6h5.2c.8 0 1.4.6 1.4 1.4s-.7 1.4-1.5 1.4zM2.2.5c-.2 0-.4.2-.4.4s.2.3.4.3h5.2c.2 0 .4-.2.4-.4S7.5.5 7.3.5H2.2z"
          id="Path_4346"
        />
        <path
          className="st1t"
          d="M4.7 9c-.8 0-1.4-.6-1.4-1.3s.6-1.3 1.3-1.3S6 7 6 7.7 5.4 9 4.7 9zm0-1.6c-.2 0-.3.2-.3.3s.1.3.3.3.3-.1.3-.3-.2-.3-.3-.3z"
          id="Ellipse_486"
        />
        <path
          className="st1t"
          d="M8.6 9c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3S10 7 10 7.7 9.4 9 8.6 9zm0-1.6c-.2 0-.3.2-.3.3s.1.3.3.3.4-.1.4-.3-.2-.3-.4-.3z"
          id="Ellipse_487"
        />
        <path
          className="st1t"
          d="M.8 9C.1 9-.5 8.4-.5 7.7S.1 6.4.8 6.4c.7 0 1.3.6 1.3 1.3S1.6 9 .8 9zm0-1.6c-.2 0-.3.2-.3.3s.2.3.3.3c.2 0 .4-.1.4-.3S1 7.4.8 7.4z"
          id="Ellipse_488"
        />
      </g>
    </g>
  </svg>
);

export const MobNextArrowIcon = () => (
  <svg x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
    <circle cx={12} cy={12} r={12} fill="#2c7357" />
    <path
      d="M.5 12.2c.1 0 .3 0 .3-.1L7 6.5c.2-.2.2-.5 0-.7L.9.1C.6-.1.3 0 .1.2 0 .4 0 .7.2.9l5.7 5.2-5.7 5.2c-.2.2-.2.5 0 .7 0 .2.2.2.3.2z"
      fill="#adf0d5"
      transform="translate(8.861 6)"
    />
  </svg>
);
export const MobPrevArrowIcon = () => (
  <svg x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
    <g transform="translate(-20 -1622)">
      <circle cx={32} cy={1634} r={12} fill="#2c7357" />
      <path
        d="M6.6 12.2c-.1 0-.3 0-.3-.1L.2 6.5C0 6.3-.1 6 .1 5.8L6.2.2c.3-.3.6-.2.8 0 .2.2.2.5 0 .7L1.3 6.1 7 11.4c.2.2.2.5 0 .7-.1.1-.2.1-.4.1z"
        fill="#adf0d5"
        transform="translate(-396 -258) translate(424 1886)"
      />
    </g>
  </svg>
);

export const DropdownBlack = () => (
  <svg x="0px" y="0px" viewBox="0 0 13.4 9.3" xmlSpace="preserve">
    <path d="M.7.7l6 8.1 6-8.1" fill="#fff" />
    <path d="M6.7 9.3c-.2 0-.3-.1-.4-.2L.3 1C.1.8.2.5.4.3c.2-.2.5-.1.7.1L6.7 8 12.3.4c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-6 8.1c-.1.1-.2.2-.4.2z" />
  </svg>
);

export const PriceFreeIcon = () => (
  <svg x="0px" y="0px" viewBox="0 0 96 96">
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 97.41 121"
    >
      <path
        className="cls-1"
        d="M118.9,125.09h-35a4.69,4.69,0,0,1-4.71-4.57L76.6,40l-2.83,80.52a4.69,4.69,0,0,1-4.71,4.55H32.26a5.38,5.38,0,0,1-4.9-7.61L70.72,22.21a6.18,6.18,0,0,1,5.69-3.67h0a6.2,6.2,0,0,1,5.69,3.75l41.68,95.27a5.38,5.38,0,0,1-4.93,7.53ZM77.26,19.94a.58.58,0,0,1,0,.19l3.2,100.35a3.37,3.37,0,0,0,3.38,3.28h35a4,4,0,0,0,3.71-5.67L80.93,22.82A4.87,4.87,0,0,0,77.26,19.94ZM76,19.88a4.86,4.86,0,0,0-4.09,2.88L28.57,118a4.05,4.05,0,0,0,3.69,5.73h36.8a3.38,3.38,0,0,0,3.39-3.27L76,20.13A1,1,0,0,1,76,19.88Z"
        transform="translate(-26.87 -18.54)"
      ></path>
      <path
        className="cls-1"
        d="M54.63,71.66a.28.28,0,0,1-.13,0,.34.34,0,0,1-.18-.44l4.4-10.32a.35.35,0,0,1,.44-.18.34.34,0,0,1,.17.44l-4.4,10.32A.32.32,0,0,1,54.63,71.66Z"
        transform="translate(-26.87 -18.54)"
      ></path>
      <path
        className="cls-1"
        d="M60.19,120.61H39.78a4.3,4.3,0,0,1-4-6l17-39.82a.34.34,0,0,1,.44-.17.32.32,0,0,1,.17.43l-17,39.82a3.62,3.62,0,0,0,3.34,5H60.19a.34.34,0,0,1,0,.67Z"
        transform="translate(-26.87 -18.54)"
      ></path>
      <path
        className="cls-1"
        d="M101.7,82.42a.35.35,0,0,1-.31-.21L87.66,49.46a.33.33,0,0,1,.18-.43.32.32,0,0,1,.43.17L102,82a.33.33,0,0,1-.18.44A.31.31,0,0,1,101.7,82.42Z"
        transform="translate(-26.87 -18.54)"
      ></path>
      <path
        className="cls-1"
        d="M86.62,46.46a.35.35,0,0,1-.31-.21L81.74,35.36a.34.34,0,0,1,.62-.26L86.92,46a.33.33,0,0,1-.17.44A.31.31,0,0,1,86.62,46.46Z"
        transform="translate(-26.87 -18.54)"
      ></path>
      <path
        className="cls-1"
        d="M81.23,33.6a.34.34,0,0,1-.31-.2l-1.11-2.66A.34.34,0,0,1,80,30.3a.33.33,0,0,1,.43.18l1.11,2.66a.33.33,0,0,1-.17.43Z"
        transform="translate(-26.87 -18.54)"
      ></path>
      <path
        className="cls-1"
        d="M77.4,139.54H73.79a3.54,3.54,0,0,1-3.05-1.75l-7.64-13a.67.67,0,1,1,1.15-.67l7.63,13a2.24,2.24,0,0,0,1.91,1.09H77.4a2.19,2.19,0,0,0,1.85-1l8.61-13.15a.66.66,0,1,1,1.11.73l-8.61,13.15A3.53,3.53,0,0,1,77.4,139.54Z"
        transform="translate(-26.87 -18.54)"
      ></path>
      <path
        className="cls-1"
        d="M76.05,137.38h0a.34.34,0,0,1-.33-.34l.92-80.7A.32.32,0,0,1,77,56h0a.33.33,0,0,1,.33.33l-.91,80.7A.33.33,0,0,1,76.05,137.38Z"
        transform="translate(-26.87 -18.54)"
      ></path>
    </svg>
  </svg>
);

export const BasicIcon = () => (
  <svg x="0px" y="0px" viewBox="0 0 91 125.1">
    <path
      className="st0"
      d="M949.5 532.2c-.3 0-.6-.2-.7-.4-1.3-2.9-2.5-5.5-2.5-5.5-2.3-5.5-3.6-11.3-3.6-17.3 0-.4.3-.8.7-.8.4 0 .8.3.8.7 0 5.8 1.2 11.4 3.5 16.7 0 0 1.2 2.6 2.5 5.5.2.4 0 .8-.4 1-.1.1-.2.1-.3.1zM943.6 504.9c-.5 0-.8-.4-.7-.8 1.1-14.7 8.5-25.8 17.1-25.8 8.6 0 15.9 11 17.1 25.6 0 .4-.3.8-.7.8-.4 0-.8-.3-.8-.7-1.1-13.8-7.8-24.2-15.6-24.2s-14.5 10.5-15.6 24.4c-.1.4-.4.7-.8.7zM970.3 531.9c-.1 0-.2 0-.3-.1-.4-.2-.5-.6-.4-1 1.2-2.6 2.3-4.9 2.3-4.9 2.4-5.2 3.6-10.8 3.8-16.5 0-.4.3-.7.8-.7.4 0 .7.4.7.8-.1 5.9-1.4 11.7-3.9 17.1 0 0-1.1 2.3-2.3 4.9-.2.2-.5.4-.7.4zM959.7 602.7c-3.4 0-3.6-2.6-3.7-4-.1-1.3-.5-6.2-.6-8.1h-14.9c-.4 0-.8-.3-.8-.8v-7.6c0-.4.3-.8.8-.8h14.7c-.2-4.7-1.3-28.7-1.5-32.8-.2-3.8-1-7.6-2.4-11.1-.3-.7-.7-1.7-1.2-2.8-.2-.4 0-.8.4-1 .4-.2.8 0 1 .4.5 1.1.9 2.1 1.2 2.8 1.5 3.7 2.4 7.6 2.5 11.6l1.5 33.6c0 .2-.1.4-.2.6-.1.1-.3.2-.5.2h-14.7v6.1h14.9c.4 0 .7.3.7.7 0 0 .5 7.2.7 8.8.1 1.7.4 2.5 2.2 2.5s2.1-.8 2.2-2.5c.1-1.6.7-8.8.7-8.8 0-.4.4-.7.7-.7h14.8v-6.1h-14.7c-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.6 0 0 1.3-29 1.5-33.6.2-4 1-7.9 2.5-11.6.3-.7.7-1.7 1.2-2.8.2-.4.6-.5 1-.4.4.2.5.6.4 1-.5 1.1-.9 2.1-1.2 2.8-1.5 3.5-2.3 7.3-2.4 11.1-.2 4.1-1.3 28.1-1.5 32.8H979c.4 0 .8.3.8.8v7.6c0 .4-.3.8-.8.8h-15c-.1 1.8-.5 6.8-.6 8.1-.1 1.4-.2 4-3.7 4z"
      transform="translate(-914.238 -477.587)"
    />
    <path
      className="st0"
      d="M947.4 498.9c-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.3 1.7-9.9 6.9-16.5 12.9-16.5 5.9 0 11.1 6.6 12.9 16.5 0 .1 0 .2-.1.3s-.2.1-.3.1h-25zm12.5-16.3c-5.4 0-10.4 6.4-12.1 15.5H972c-1.7-9.1-6.6-15.5-12.1-15.5z"
      transform="translate(-914.238 -477.587)"
    />
    <path
      className="st0"
      d="M918.1 568.7h-.2c-1-.5-1.5-1.3-1.7-2.4-.2-1.7.6-3.6 1.6-4.5 1.5-1.4 35.7-34.4 38.5-37.1-.4-1-.4-2.1 0-3l-42.1-40.4c-.1-.1-.1-.3 0-.5.8-.9 1.8-1.4 2.9-1.5 1.6 0 3.6 1 5.2 2.7 1.9 2 33.3 35 35.9 37.7.9-.4 1.8-.4 2.7-.1l40.5-41.9c.1-.1.3-.1.5 0 .1.1 1.8 1.5 1.9 3.5.1 1.2-.4 2.3-1.5 3.3-3.2 3.1-36.4 34.9-39.1 37.4.3.8.3 1.7 0 2.6l41.8 40.2c.1.1.1.2.1.3-.1.8-.8 1.5-1.7 1.8-.8.3-3.1.6-5.9-2.2-3.5-3.4-33.9-35.3-36.4-38-.9.3-1.8.3-2.7 0l-40.1 42c0 .1-.1.1-.2.1zm-3-87.8l42 40.3c.1.1.1.3.1.4-.5.9-.5 2 0 2.9.1.1 0 .3-.1.4-.4.4-37.1 35.8-38.7 37.3-1 .9-1.6 2.6-1.4 3.9.1.8.5 1.4 1.1 1.8l40.1-41.9c.1-.1.3-.1.4-.1.8.4 1.7.4 2.6 0 .1-.1.3 0 .4.1.3.3 33 34.6 36.6 38.1 1.8 1.7 3.7 2.5 5.2 2 .6-.2 1.1-.6 1.2-1.1l-41.8-40.3c-.1-.1-.1-.3-.1-.4.3-.8.4-1.7 0-2.5-.1-.1 0-.3.1-.4.4-.3 35.9-34.4 39.2-37.6.9-.9 1.3-1.8 1.3-2.8-.1-1.3-1-2.3-1.4-2.7l-40.4 41.8c-.1.1-.3.1-.4.1-.8-.3-1.8-.3-2.6.1-.1.1-.3 0-.4-.1 0 0-34.2-35.9-36.1-37.9-1.5-1.6-3.3-2.5-4.7-2.4-.9 0-1.6.4-2.2 1zM956.1 588.8c-.2 0-.3-.2-.4-.3l-.1-4.3c0-.2.1-.4.3-.4.2 0 .4.1.4.3l.1 4.3c.1.2-.1.4-.3.4zM963.5 588.7c-.2 0-.4-.2-.3-.4v-4.7c0-.2.2-.3.3-.3.2 0 .3.2.3.4v4.7c.1.1-.1.3-.3.3z"
      transform="translate(-914.238 -477.587)"
    />
  </svg>
);

export const PriceStandardIcon = () => (
  <svg
    id="Layer_3"
    data-name="Layer 3"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 143.07 114.21"
  >
    <path
      className="cls-1"
      d="M75.28,127.19H73.14a.54.54,0,0,1-.54-.54v-7.22c-.53-1.65-8.51-27-9.3-51.19L7.12,64.44a3.75,3.75,0,0,1-3.49-3.73V45.14a4.77,4.77,0,0,1,4.43-4.73l53.73-3.7A4.42,4.42,0,0,1,62,33.8a1.88,1.88,0,0,1,.58-.64,3.32,3.32,0,0,1-.25-2,2.16,2.16,0,0,1,1-1.56c0-1,.06-2.18.08-3.29,0-1.47,0-2.63.12-3.1l0-.15c.14-.91.49-3.32,3.3-3.42a.54.54,0,0,1,.56.52.54.54,0,0,1-.52.56c-1.77.06-2.1,1.32-2.27,2.5l0,.15c-.06.4-.08,1.64-.1,3s0,2.61-.11,3.64a.53.53,0,0,1-.35.48,1.11,1.11,0,0,0-.62.9A1.93,1.93,0,0,0,63.74,33a.53.53,0,0,1,.18.54.54.54,0,0,1-.4.4.83.83,0,0,0-.58.43A4.28,4.28,0,0,0,63,37a.56.56,0,0,1-.07.47.54.54,0,0,1-.41.23L8.13,41.48a3.68,3.68,0,0,0-3.42,3.66V60.71a2.68,2.68,0,0,0,2.48,2.66L63.86,67.2a.53.53,0,0,1,.5.52c.71,24.89,9.2,51.2,9.29,51.46a.47.47,0,0,1,0,.17v6.76h1.6a.54.54,0,1,1,0,1.08Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M71.68,123.54h0l-18.06-.22a5.09,5.09,0,0,1-5.08-5.08v-5.09a4.88,4.88,0,0,1,3.12-4.56l16.42-6.43a.54.54,0,1,1,.39,1L52,109.59a3.8,3.8,0,0,0-2.43,3.56v5.09a4,4,0,0,0,4,4l17.68.21.83-2.28a.55.55,0,0,1,.69-.33.54.54,0,0,1,.32.69l-1,2.65A.55.55,0,0,1,71.68,123.54Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M56.16,20.7a1.94,1.94,0,0,1-1.27-.44,1.35,1.35,0,0,1-.41-1V17.64a1.61,1.61,0,0,1,1.72-1.47H70.39l-.06-.66a.51.51,0,0,1,.13-.41.53.53,0,0,1,.4-.18h1.67V13.51a.54.54,0,0,1,.54-.54h2.21a.54.54,0,0,1,.54.54.54.54,0,0,1-.54.54H73.6v1.41a.54.54,0,0,1-.53.54H71.46l.07.65a.57.57,0,0,1-.14.42.54.54,0,0,1-.4.18H56.23s-.67.05-.67.39v1.61a.27.27,0,0,0,.07.22,1,1,0,0,0,.57.15H72.81a.54.54,0,1,1,0,1.08H56.16Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M29.32,65l-.53,0s.21-3,.37-5.08a3.41,3.41,0,0,0-.83-2.62,2.85,2.85,0,0,0-2.15-.9c-2.1,0-11.35-.16-14.06-.26a3.51,3.51,0,0,0-2.61.7,2.27,2.27,0,0,0-.62,1.69V64a.27.27,0,0,1-.54,0V58.51a2.8,2.8,0,0,1,.79-2.08,4,4,0,0,1,3-.85c2.71.1,11.94.26,14,.26a3.46,3.46,0,0,1,2.55,1.08,3.94,3.94,0,0,1,1,3C29.54,62,29.32,65,29.32,65Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M6,50.05a.27.27,0,0,1-.27-.27v-3.4c0-.62.34-2.63,4.77-2.93,3.89-.27,44-2.8,44.43-2.82a.26.26,0,0,1,.29.25.27.27,0,0,1-.26.28c-.4,0-40.53,2.56-44.42,2.82-3.15.22-4.28,1.38-4.28,2.4v3.4A.27.27,0,0,1,6,50.05Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M57.45,64.79H57.2c-1.64,0-10.65-.63-17.92-1.13a.27.27,0,0,1-.25-.29.29.29,0,0,1,.29-.25c7.26.5,16.26,1.1,17.89,1.13a4,4,0,0,0,2.63-.57,2.91,2.91,0,0,0,.87-2.41c0-2.57-.37-10-.37-10.09a.26.26,0,0,1,.25-.28h0a.27.27,0,0,1,.27.25c0,.07.42,7.54.37,10.13a3.46,3.46,0,0,1-1.07,2.83A4.28,4.28,0,0,1,57.45,64.79Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M37.08,63.51h0l-2.22-.16a.27.27,0,0,1,0-.53L37.1,63a.28.28,0,0,1,.25.29A.27.27,0,0,1,37.08,63.51Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M56.35,110.23a.26.26,0,0,1-.25-.19.27.27,0,0,1,.17-.34l10.53-3.45a.27.27,0,1,1,.17.51l-10.53,3.46Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M60.85,122.47a.27.27,0,0,1-.26-.27v-4.47a.27.27,0,1,1,.53,0v4.47A.27.27,0,0,1,60.85,122.47Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M67.84,122.78"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M67.84,123.05a.27.27,0,0,1-.26-.27v-4.36a.27.27,0,1,1,.53,0v4.36A.27.27,0,0,1,67.84,123.05Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M63.53,66.74a.54.54,0,0,1-.53-.51c0-.2-1.36-20.67-1.28-28.53a.49.49,0,0,1,.55-.53.52.52,0,0,1,.53.54c-.08,7.82,1.26,28.25,1.27,28.45a.53.53,0,0,1-.5.57Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M62.79,20.18a.27.27,0,0,1-.27-.27V17.44a.27.27,0,1,1,.54,0v2.47A.27.27,0,0,1,62.79,20.18Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M68.2,20.43a.27.27,0,0,1-.27-.27V17.07a.27.27,0,0,1,.54,0v3.09A.27.27,0,0,1,68.2,20.43Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M77.2,127.19H75.05a.54.54,0,0,1,0-1.08h1.61v-6.76a.88.88,0,0,1,0-.17c.09-.26,8.58-26.57,9.29-51.46a.54.54,0,0,1,.5-.52l56.67-3.83a2.68,2.68,0,0,0,2.48-2.66V45.14a3.68,3.68,0,0,0-3.42-3.66L87.83,37.74a.54.54,0,0,1-.41-.23.56.56,0,0,1-.07-.47,4.22,4.22,0,0,0,0-2.71.81.81,0,0,0-.58-.43.56.56,0,0,1-.4-.4.57.57,0,0,1,.18-.54A2,2,0,0,0,87,31.33a1.13,1.13,0,0,0-.62-.9A.53.53,0,0,1,86,30c-.06-1-.09-2.4-.11-3.64s0-2.56-.1-3l0-.15c-.18-1.18-.51-2.44-2.27-2.5a.54.54,0,0,1-.52-.56.56.56,0,0,1,.55-.52c2.81.1,3.17,2.51,3.3,3.42l0,.15a30.66,30.66,0,0,1,.12,3.1c0,1.11,0,2.31.09,3.29a2.22,2.22,0,0,1,1,1.56,3.48,3.48,0,0,1-.25,2,1.86,1.86,0,0,1,.57.64,4.49,4.49,0,0,1,.22,2.91l53.73,3.7a4.76,4.76,0,0,1,4.42,4.73V60.71a3.75,3.75,0,0,1-3.49,3.73L87,68.24c-.78,24.2-8.77,49.54-9.3,51.19v7.22A.54.54,0,0,1,77.2,127.19Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M78.66,123.54a.55.55,0,0,1-.51-.36l-1-2.65a.54.54,0,0,1,.32-.69.55.55,0,0,1,.69.33l.83,2.28,17.68-.21a4,4,0,0,0,4-4v-5.09a3.8,3.8,0,0,0-2.43-3.56l-16.42-6.43a.54.54,0,1,1,.39-1l16.43,6.43a4.87,4.87,0,0,1,3.11,4.56v5.09a5.09,5.09,0,0,1-5.08,5.08l-18.06.22Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M94.16,20.7H77.53a.54.54,0,1,1,0-1.08H94.1a.93.93,0,0,0,.6-.15.26.26,0,0,0,.08-.22V17.64c0-.34-.69-.39-.7-.39H79.34a.55.55,0,0,1-.4-.18.57.57,0,0,1-.14-.42l.07-.65h-1.6a.54.54,0,0,1-.54-.54V14.05H75.05a.54.54,0,0,1-.54-.54.54.54,0,0,1,.54-.54h2.22a.54.54,0,0,1,.54.54v1.41h1.66a.52.52,0,0,1,.4.18.51.51,0,0,1,.13.41l-.06.66H94.11c.85,0,1.74.51,1.74,1.47v1.61a1.35,1.35,0,0,1-.41,1A1.94,1.94,0,0,1,94.16,20.7Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M121,65s-.21-3-.37-5.08a3.9,3.9,0,0,1,1-3,3.42,3.42,0,0,1,2.54-1.08c2.1,0,11.34-.16,14-.26a3.93,3.93,0,0,1,3,.85,2.8,2.8,0,0,1,.79,2.08V64a.27.27,0,0,1-.27.27.28.28,0,0,1-.27-.27V58.51a2.27,2.27,0,0,0-.62-1.69,3.49,3.49,0,0,0-2.61-.7c-2.71.1-12,.26-14.06.26a2.85,2.85,0,0,0-2.15.9,3.45,3.45,0,0,0-.83,2.62c.16,2.1.38,5.08.38,5.08Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M89.48,122.47a.27.27,0,0,1-.27-.27v-4.47a.27.27,0,0,1,.54,0v4.47A.27.27,0,0,1,89.48,122.47Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M82.49,122.78"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M82.49,123.05a.27.27,0,0,1-.27-.27v-4.36a.27.27,0,1,1,.54,0v4.36A.27.27,0,0,1,82.49,123.05Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M86.8,67.75h0a.54.54,0,0,1-.51-.57c0-.22,1.27-21.65,1.18-29.47a.53.53,0,0,1,.53-.54.56.56,0,0,1,.55.53c.08,7.86-1.17,29.33-1.18,29.54A.55.55,0,0,1,86.8,67.75Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M87.54,20.18a.27.27,0,0,1-.27-.27V17.44a.27.27,0,0,1,.54,0v2.47A.27.27,0,0,1,87.54,20.18Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M82.13,20.43a.28.28,0,0,1-.27-.27V17.07a.27.27,0,0,1,.27-.26.27.27,0,0,1,.27.26v3.09A.27.27,0,0,1,82.13,20.43Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M71.49,20.43a.27.27,0,0,1-.27-.25c0-.56-.14-3.33,1.11-3.6a.25.25,0,0,1,.22.05C74,17.75,74,17.75,75.28,17.75c.73.13,1,.05,2.5-1.12a.25.25,0,0,1,.22-.05c1.26.27,1.15,3,1.11,3.6a.27.27,0,0,1-.27.25h0a.27.27,0,0,1-.25-.28c.06-1.12-.08-2.71-.59-3-1.42,1.09-1.83,1.31-2.75,1.15-1.37,0-1.44,0-2.9-1.15-.51.3-.65,1.89-.58,3a.28.28,0,0,1-.26.28Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M74.18,24.14a42.22,42.22,0,0,1-7.46-.61.27.27,0,0,1-.21-.31.28.28,0,0,1,.32-.22,44.63,44.63,0,0,0,16.42-.35.27.27,0,0,1,.32.21.28.28,0,0,1-.2.32A42.94,42.94,0,0,1,74.18,24.14Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M74.71,31A26.64,26.64,0,0,1,66.43,30a.26.26,0,0,1-.16-.34.27.27,0,0,1,.34-.16c.07,0,6.62,2.32,17.55,0a.25.25,0,0,1,.32.2.27.27,0,0,1-.2.32A46.06,46.06,0,0,1,74.71,31Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75,34.84a36.66,36.66,0,0,1-9-1,.27.27,0,0,1,.15-.52,38.87,38.87,0,0,0,17.61,0,.27.27,0,0,1,.13.53A38.83,38.83,0,0,1,75,34.84Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M74.65,38.66A31.32,31.32,0,0,1,66,37.57a.26.26,0,0,1-.17-.34.28.28,0,0,1,.34-.17,34.45,34.45,0,0,0,18.25-.31.27.27,0,0,1,.15.52A36.06,36.06,0,0,1,74.65,38.66Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M74.63,85.45a38.43,38.43,0,0,1-6.53-.56.27.27,0,0,1-.22-.31.28.28,0,0,1,.31-.22c.08,0,8.11,1.49,13.71-.49a.26.26,0,0,1,.34.16.26.26,0,0,1-.16.34A22.91,22.91,0,0,1,74.63,85.45Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75.05,88.18a31.51,31.51,0,0,1-7-.71.27.27,0,0,1-.2-.32.28.28,0,0,1,.33-.2,33.5,33.5,0,0,0,13.52,0,.27.27,0,0,1,.11.53A32.49,32.49,0,0,1,75.05,88.18Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75.8,72.73a8.19,8.19,0,0,1-8.18-8.18V51.62a8.18,8.18,0,0,1,16.36,0V64.55A8.19,8.19,0,0,1,75.8,72.73ZM75.8,44a7.65,7.65,0,0,0-7.64,7.65V64.55a7.64,7.64,0,0,0,15.28,0V51.62A7.65,7.65,0,0,0,75.8,44Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75.7,57.72a26.11,26.11,0,0,1-7.9-1.29.26.26,0,0,1-.16-.34.26.26,0,0,1,.34-.16c.09,0,9.27,3.15,15.34-.69a.28.28,0,0,1,.37.09.27.27,0,0,1-.09.37A14.71,14.71,0,0,1,75.7,57.72Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75.62,66.76a25.63,25.63,0,0,1-7.78-1.19.27.27,0,0,1-.16-.35.26.26,0,0,1,.34-.16c.08,0,8,2.8,15.33-.31a.27.27,0,1,1,.21.5A20.49,20.49,0,0,1,75.62,66.76Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M75.8,72.42a.27.27,0,0,1-.27-.27V66.83a.27.27,0,0,1,.54,0v5.32A.27.27,0,0,1,75.8,72.42Z"
      transform="translate(-3.63 -12.97)"
    ></path>
    <path
      className="cls-1"
      d="M90.31,54.36h0a.28.28,0,0,1-.27-.28c0-.08.2-8.09.29-9.87.12-2.09,1-3.42,5-3.58.44,0,40.57,2.55,44.46,2.82a.26.26,0,0,1,.25.28c0,.15-.14.3-.28.25-3.9-.26-44-2.79-44.43-2.82-4,.17-4.39,1.49-4.48,3.08-.09,1.77-.29,9.77-.29,9.85A.27.27,0,0,1,90.31,54.36Z"
      transform="translate(-3.63 -12.97)"
    ></path>
  </svg>
);

export const PriceProIcon = () => (
  <svg data-name="Layer 2" viewBox="0 0 86.4 139.36">
    <path
      className="cls-1"
      d="M87 129.65h-9.76a.27.27 0 010-.54H87a.27.27 0 010 .54z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-2"
      d="M87.57 52a.25.25 0 01-.26-.27c0-.28.12-28 0-31 0-.76-.93-18.62-12-18.62h-.08a9.16 9.16 0 00-6.7 3c-4.57 4.72-5.82 14-5.75 16.8.08 3.66.17 28.94.17 29.2a.27.27 0 01-.27.27.27.27 0 01-.27-.27c0-.26-.09-25.53-.17-29.19-.05-2.15.85-12 5.91-17.19a9.69 9.69 0 017.08-3.12h.09C86.88 1.63 87.8 20 87.83 20.77c.13 2.93 0 30.71 0 31a.26.26 0 01-.26.23z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-2"
      d="M66.17 20a7.44 7.44 0 01-3.55-.9.27.27 0 11.28-.46 7 7 0 006.09.19.28.28 0 01.36.13.28.28 0 01-.13.36 7.27 7.27 0 01-3.05.68zM66 22.42a9.31 9.31 0 01-3.53-.76.27.27 0 01.23-.49s3.43 1.56 6 0a.28.28 0 01.37.09.26.26 0 01-.09.37 5.62 5.62 0 01-2.98.79zM67.12 13.1h-.06a.27.27 0 01-.2-.33c0-.23 1.35-5.75 6-8.06a.27.27 0 01.36.12.26.26 0 01-.12.36c-4.4 2.2-5.68 7.65-5.7 7.7a.26.26 0 01-.28.21zM83.92 19.89a16 16 0 01-3.06-.32.26.26 0 01-.2-.32A.27.27 0 0181 19s4.14.89 6.1-.39a.27.27 0 11.29.45 6.47 6.47 0 01-3.47.83zM84 22a10.63 10.63 0 01-2.8-.36.27.27 0 01-.18-.33.28.28 0 01.33-.19 9.57 9.57 0 005.76-.28.27.27 0 11.23.49A8 8 0 0184 22zM50.27 90.42a.27.27 0 01-.27-.27c0-.29-.08-29.19 0-31.71v-4.42c-.07-4.17-.17-9.89.21-11.79 1.31-6.57 3.48-10.11 6.45-10.54a2.69 2.69 0 012.19.68c2.62 2.24 3.54 9.35 3.57 11.68v11.61a.27.27 0 01-.26.27.26.26 0 01-.26-.27v-11.6c0-2.18-.94-9.18-3.39-11.28a2.12 2.12 0 00-1.77-.56c-2.71.39-4.73 3.8-6 10.12-.37 1.84-.27 7.52-.2 11.67 0 2 .06 3.63 0 4.45-.08 2.51 0 31.4 0 31.69a.27.27 0 01-.27.27z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-2"
      d="M55.92 46.63a13.22 13.22 0 01-5.84-1.32.27.27 0 01-.1-.37.25.25 0 01.36-.1 13 13 0 0011.12 0 .27.27 0 01.36.13.27.27 0 01-.13.36 13.39 13.39 0 01-5.77 1.3zM55.62 48.85a12 12 0 01-3.31-.43.27.27 0 11.16-.51 12.5 12.5 0 006.24 0 .26.26 0 11.14.51 11.69 11.69 0 01-3.23.43zM53.49 42.07a.29.29 0 01-.25-.3 19.89 19.89 0 011.94-6.71.26.26 0 01.36-.11.27.27 0 01.11.36 19.63 19.63 0 00-1.87 6.51.27.27 0 01-.29.25zM56.29 59.33a17.54 17.54 0 01-5.29-.79.27.27 0 01-.16-.35.26.26 0 01.34-.16A16.68 16.68 0 0061 58a.26.26 0 01.34.16.27.27 0 01-.16.35 14.74 14.74 0 01-4.89.82zM56 61.53a19.19 19.19 0 01-5.36-.79.28.28 0 01-.18-.34.27.27 0 01.34-.17c.06 0 5.38 1.68 9.55 0a.27.27 0 01.35.15.26.26 0 01-.15.35 12.18 12.18 0 01-4.55.8zM55.81 71.87a17.31 17.31 0 01-5.51-1.06.27.27 0 01-.15-.35.26.26 0 01.35-.15s5 1.89 8.13.51A.26.26 0 0159 71a.27.27 0 01-.14.35 7.64 7.64 0 01-3.05.52zM55.56 74.62a13.11 13.11 0 01-5.28-1.28.28.28 0 01-.12-.37.27.27 0 01.36-.11s4.38 2.16 7.69.71a.26.26 0 01.35.14.26.26 0 01-.14.35 7 7 0 01-2.86.56zM53.26 85.36a5.18 5.18 0 01-3.19-1.27.27.27 0 010-.38.26.26 0 01.38 0 4 4 0 004.37.75.27.27 0 01.24.49 4.12 4.12 0 01-1.8.41zM99.38 90a.27.27 0 01-.27-.27c0-.29.09-28.77 0-31.28v-4.44c.07-4.15.17-9.84-.2-11.68-1.27-6.32-3.28-9.73-6-10.12a2.1 2.1 0 00-1.76.56c-2.46 2.09-3.36 9.1-3.39 11.28v11.6a.28.28 0 01-.27.27.27.27 0 01-.27-.27V44.04c0-2.33.95-9.44 3.58-11.68a2.68 2.68 0 012.2-.67c3 .43 5.13 4 6.45 10.54.38 1.9.28 7.63.21 11.8 0 1.94-.07 3.61 0 4.41.09 2.52 0 31 0 31.3a.27.27 0 01-.28.26z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-2"
      d="M93.73 46.63A13.39 13.39 0 0188 45.32a.27.27 0 01-.12-.36.26.26 0 01.35-.13 12.92 12.92 0 0011.12 0 .27.27 0 01.37.1.28.28 0 01-.11.37 13.12 13.12 0 01-5.88 1.33zM94 48.85a11.79 11.79 0 01-3.23-.43.27.27 0 01-.19-.33.26.26 0 01.33-.18 12.55 12.55 0 006.25 0 .27.27 0 01.15.51 11.9 11.9 0 01-3.31.43zM90.33 42.07a.29.29 0 01-.24-.3A19.63 19.63 0 0192 35.06a.26.26 0 01.36-.11.27.27 0 01.11.36 19.63 19.63 0 00-1.87 6.51.28.28 0 01-.27.25zM93.37 59.33a14.7 14.7 0 01-4.87-.79.28.28 0 01-.17-.35.27.27 0 01.35-.16 16.68 16.68 0 009.77 0 .27.27 0 01.34.16.28.28 0 01-.17.35 17.52 17.52 0 01-5.25.79zM93.64 61.53a12.27 12.27 0 01-4.56-.8.26.26 0 01-.15-.35.27.27 0 01.35-.15c4.17 1.68 9.5 0 9.55 0a.26.26 0 01.34.17.27.27 0 01-.17.34 19.27 19.27 0 01-5.36.79zM93.85 71.87a7.57 7.57 0 01-3-.56.26.26 0 01-.14-.35.25.25 0 01.35-.14c3.17 1.37 8.09-.5 8.14-.51a.27.27 0 01.35.15.28.28 0 01-.16.35 17.14 17.14 0 01-5.54 1.06zM94.09 74.62a7 7 0 01-2.86-.56.26.26 0 01-.14-.35.27.27 0 01.36-.14c3.31 1.45 7.64-.69 7.68-.71a.27.27 0 01.37.11.29.29 0 01-.12.37 13.18 13.18 0 01-5.29 1.28zM96.39 85.36a4 4 0 01-1.78-.42.27.27 0 01-.13-.36.26.26 0 01.36-.13 4.06 4.06 0 004.37-.75.27.27 0 11.37.39 5.14 5.14 0 01-3.19 1.27zM94.61 129.79H92c-1.21 0-3.72 0-4.69-2.41a.27.27 0 01.15-.35.28.28 0 01.35.15c.73 1.82 2.45 2.07 4.19 2.07h4.59c2.11-.06 3.48-1.05 3.48-2.54v-5a.27.27 0 11.54 0v5c0 1.8-1.57 3-4 3.08z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-1"
      d="M75.54 137.93a2.24 2.24 0 01-2.21-2.15v-1.63c-2.58-.31-10.57-1.52-10.85-4.73 0-.62-.07-1.21-.09-1.77-.09-2.4-.2-3.48-2.07-4-1.32-.35-5.7-1.15-10.34-2-5.37-1-11.45-2.07-14.09-2.73-5-1.26-4.36-6.18-4.08-8.27l.06-.45a15.4 15.4 0 013.76-7.7c1-1.07 4.33-4 7.84-7.06 3.81-3.34 7.74-6.8 9.48-8.54 3.36-3.35 4-5.71 4.92-10.3C59.19 70.23 62.28 53.92 64 44c.17-1 .34-2 .53-3.2 1.85-11.14 4.65-28 11-28.36h.16c5.59 0 8.83 18.3 11.44 35.49.28 1.84.52 3.44.73 4.7.31 1.84.63 4 1 6.23C90.19 68 92.09 80.53 94.73 84c1.46 1.92 5.18 5.29 9.13 8.85 5.14 4.65 10.45 9.45 11.93 12.09 1.82 3.26 3 8.43 1.62 11.6a4.21 4.21 0 01-2.91 2.52c-2.67.65-9.7 1.93-15.34 3-3.79.68-7.06 1.28-8 1.49-2.1.49-2.73 1.13-3.1 3.08a10.29 10.29 0 00-.13 1.47c0 1.6-.12 3.41-2.9 4.46a24.72 24.72 0 01-6.91 1.27 4.59 4.59 0 01-.61 3.24 2.43 2.43 0 01-1.97.86zm0-1.07a1.37 1.37 0 001.16-.48c.63-.79.43-2.41.3-3a.54.54 0 01.1-.46.57.57 0 01.42-.21 25.1 25.1 0 007.17-1.22c2.11-.8 2.15-1.93 2.21-3.49a11.7 11.7 0 01.14-1.63c.44-2.35 1.43-3.35 3.91-3.93.93-.22 4.22-.81 8-1.51 5.63-1 12.64-2.29 15.28-2.93a3.13 3.13 0 002.17-1.91c1.2-2.75.14-7.57-1.57-10.64C113.46 103 108 98 103.14 93.67c-4-3.6-7.75-7-9.26-9C91.07 81 89.22 68.78 87.74 59c-.34-2.26-.66-4.38-1-6.22-.21-1.26-.45-2.86-.73-4.71-1.55-10.37-5.22-34.58-10.34-34.58h-.1c-5.46.33-8.28 17.31-10 27.46-.19 1.15-.37 2.23-.54 3.21-1.73 9.95-4.83 26.28-6.15 32.66-1 4.68-1.65 7.29-5.22 10.85-1.76 1.77-5.71 5.23-9.53 8.59-3.49 3.06-6.79 6-7.76 7a14.39 14.39 0 00-3.48 7.09l-.06.46c-.28 2.12-.81 6.06 3.27 7.08 2.61.65 8.67 1.75 14 2.72 4.86.88 9.06 1.65 10.43 2 2.71.74 2.78 2.71 2.86 5 0 .54 0 1.11.1 1.72.17 2 6.45 3.39 10.37 3.8a.54.54 0 01.48.54v2.11a1.18 1.18 0 001.13 1.08z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-1"
      d="M61 79.22h-.1a.53.53 0 01-.43-.62 77.43 77.43 0 012.31-9.76.54.54 0 011 .32 77.1 77.1 0 00-2.28 9.63.54.54 0 01-.5.43zM62.11 121.25a.54.54 0 01-.53-.44c0-.08-1.36-7.92-2.29-16.06A94.41 94.41 0 0159.47 86a.54.54 0 01.59-.48.53.53 0 01.48.59 93.62 93.62 0 00-.18 18.48c.93 8.1 2.27 15.92 2.28 16a.53.53 0 01-.44.62zM90 110.75h-.12a.52.52 0 01-.4-.64c3.3-14.12-.9-31.1-.94-31.27a.53.53 0 01.39-.65.52.52 0 01.65.39c.05.17 4.31 17.4 1 31.77a.54.54 0 01-.58.4zM88.11 120.58h-.15a.54.54 0 01-.37-.66l.94-3.37a.56.56 0 01.67-.37.54.54 0 01.37.66l-.94 3.37a.54.54 0 01-.52.37zM70.14 19.06a9.93 9.93 0 0010.33 0c-1.89-3.92-3-6.89-4.94-6.1s-4.6 3.98-5.39 6.1zM73.86 133.94a.28.28 0 01-.26-.28l1.85-60.06a.26.26 0 01.27-.26.27.27 0 01.27.26l1.61 59.23a.27.27 0 01-.26.28.28.28 0 01-.27-.27l-1.36-50-1.57 50.8a.27.27 0 01-.28.3zM62.25 105.23a.28.28 0 01-.24-.15.27.27 0 01.11-.36c.19-.1 4.6-2.42 8.68-1.35a.27.27 0 01-.14.53c-3.88-1-8.24 1.27-8.29 1.29a.19.19 0 01-.12.04zM88.11 105.23a.3.3 0 01-.15 0c-2.46-1.57-8-1.28-8-1.28a.27.27 0 110-.53c.23 0 5.76-.31 8.37 1.36a.27.27 0 01.09.37.29.29 0 01-.31.08z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-1"
      d="M63.32 125.7a.27.27 0 01-.11-.51c.15-.08 3.72-1.77 10.68-1a.27.27 0 01.24.3.26.26 0 01-.3.23c-6.8-.79-10.35.9-10.39.92a.27.27 0 01-.12.06zM87 125.7h-.11c-3.53-1.58-9.51-1.14-9.57-1.14a.27.27 0 01-.28-.24.26.26 0 01.24-.29c.25 0 6.18-.45 9.83 1.17a.27.27 0 01.14.36.28.28 0 01-.25.14zM73.86 129.65H63a.27.27 0 010-.54h10.86a.27.27 0 010 .54z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-1"
      d="M65.86 131.94a.27.27 0 01-.27-.27v-2a.27.27 0 01.54 0v2a.27.27 0 01-.27.27zM68.1 132.77a.27.27 0 01-.27-.27v-2.86a.27.27 0 11.54 0v2.86a.27.27 0 01-.27.27zM70.34 132.77a.27.27 0 01-.27-.27v-3.12a.27.27 0 11.54 0v3.12a.27.27 0 01-.27.27zM79.62 133.17a.27.27 0 01-.27-.27v-3.52a.27.27 0 11.54 0v3.52a.27.27 0 01-.27.27zM82.14 132.36a.27.27 0 01-.27-.27v-2.45a.27.27 0 11.53 0v2.45a.27.27 0 01-.26.27zM84.46 131.94a.27.27 0 01-.26-.27v-2a.27.27 0 11.53 0v2a.27.27 0 01-.27.27zM93.5 119.37a.27.27 0 01-.27-.22.28.28 0 01.22-.32l19.4-3.5a.28.28 0 01.31.22.27.27 0 01-.22.31l-19.4 3.5zM55.92 119.37h-.05l-19-3.5a.26.26 0 01-.22-.31.28.28 0 01.31-.22l19 3.5a.27.27 0 01.21.32.27.27 0 01-.25.21zM36.12 108.86a.16.16 0 01-.1 0 .26.26 0 01-.16-.34c.11-.28 2.74-6.78 15.07-14.28a.27.27 0 01.37.09.28.28 0 01-.09.37c-12.15 7.4-14.82 13.94-14.84 14a.27.27 0 01-.25.16zM75.6 68.45a.26.26 0 01-.27-.26L75 53.24a.26.26 0 01.3-.24.27.27 0 01.27.27l.3 15a.27.27 0 01-.27.27zM75.3 35.45a.27.27 0 01-.26-.27v-2.56a.27.27 0 01.53 0v2.56a.27.27 0 01-.27.27zM75.48 24.21a12.12 12.12 0 01-6.54-2.06.27.27 0 010-.37.27.27 0 01.38-.06c.06 0 6 4.36 12 0a.26.26 0 01.37.06.26.26 0 01-.06.38 10.29 10.29 0 01-6.15 2.05zM104.61 112.5a3.84 3.84 0 110-7.68 3.67 3.67 0 011.14.18.27.27 0 01.18.33.26.26 0 01-.34.18 3.31 3.31 0 102.06 1.87.28.28 0 01.14-.36.28.28 0 01.36.15 3.78 3.78 0 01.3 1.49 3.84 3.84 0 01-3.84 3.84zM70.36 50.64a2.5 2.5 0 01-1.31-.42 2.56 2.56 0 01-1.24-2.11c-.07-2.09 1.9-4.51 3.26-5.5a7.81 7.81 0 019.15.88c2.1 2.13 2.49 4.38 2 5.66a1.67 1.67 0 01-1.56 1.11 4.4 4.4 0 01-2.56-1.34 4.55 4.55 0 00-3-1.42 3.9 3.9 0 00-2.3 1.61 3.47 3.47 0 01-2.44 1.53zM75 42.08a6.5 6.5 0 00-3.65 1c-1.31 1-3.09 3.23-3 5a2 2 0 001 1.67c1.27.79 2 .13 3-1A4.32 4.32 0 0175 47c1.37-.14 2.47.75 3.43 1.54a4.12 4.12 0 002.22 1.21 1.13 1.13 0 001.06-.78c.45-1.08.07-3.13-1.84-5.07A6.74 6.74 0 0075 42.08zm0 5.15z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-1"
      d="M72.92 46.36a.27.27 0 01-.12 0c-.65-.32-.58-1.48-.57-1.61a.27.27 0 11.53 0c0 .37 0 1 .28 1.09a.27.27 0 01.12.36.26.26 0 01-.24.16zM77.66 46.61a.3.3 0 01-.2-.08.28.28 0 010-.39s.74-.68.31-1.24a.27.27 0 11.42-.33 1.48 1.48 0 01-.37 2 .26.26 0 01-.16.04z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-2"
      d="M55.84 129.94h-2c-2.43-.07-4-1.28-4-3.08v-5a.28.28 0 01.27-.27.27.27 0 01.27.27v5c0 1.49 1.37 2.48 3.48 2.54h4.6c1.74 0 3.45-.25 4.19-2.07a.26.26 0 01.35-.15.28.28 0 01.15.35c-1 2.41-3.49 2.41-4.69 2.41h-1.2z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-2"
      d="M58.12 141h-.77a16.45 16.45 0 00-2.53 0 3.6 3.6 0 01-2.7-1 4.35 4.35 0 01-1.32-3v-8.2a.27.27 0 11.54 0v8.2a3.73 3.73 0 001.15 2.64 3 3 0 002.29.83 15.52 15.52 0 012.6 0h.8c1 0 4-1 4.12-3.85.07-3.12 0-7.18 0-7.22a.27.27 0 01.26-.27.28.28 0 01.27.26s.07 4.11 0 7.24c-.08 3.31-3.44 4.37-4.66 4.38z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-2"
      d="M51.07 137.24a.28.28 0 01-.27-.22.28.28 0 01.22-.32 51.62 51.62 0 0111.57-.36.27.27 0 01.25.29.29.29 0 01-.29.25 50 50 0 00-11.43.35zM61.38 139.59h-.09c-3.86-1.49-8.82-.14-8.86-.12a.27.27 0 11-.15-.52c.21-.06 5.17-1.41 9.2.13a.26.26 0 01.15.35.26.26 0 01-.25.16z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-2"
      d="M56.87 136.72a.27.27 0 01-.27-.27v-4.78a.27.27 0 11.54 0v4.78a.27.27 0 01-.27.27zM52.93 133.94a.27.27 0 01-.27-.27V130a.27.27 0 01.54 0v3.68a.27.27 0 01-.27.26zM60.27 134.33a.27.27 0 01-.27-.27v-4.58a.27.27 0 01.27-.27.28.28 0 01.27.27v4.58a.28.28 0 01-.27.27zM95.87 140.84h-.24a18.11 18.11 0 00-2.54 0 6.47 6.47 0 01-.83 0c-1.21 0-4.58-1.06-4.65-4.37-.08-3.14 0-7.2 0-7.24a.27.27 0 01.27-.27.26.26 0 01.26.28s-.07 4.09 0 7.21c.07 2.88 3.09 3.84 4.13 3.85h.79a15.52 15.52 0 012.6 0 2.93 2.93 0 002.29-.83 3.74 3.74 0 001.16-2.64v-8.2a.27.27 0 11.53 0v8.2a4.29 4.29 0 01-1.32 3 3.52 3.52 0 01-2.45 1.01z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-2"
      d="M99.38 137.09a50.79 50.79 0 00-11.43-.35.28.28 0 01-.29-.25.27.27 0 01.25-.29 50.79 50.79 0 0111.56.36.27.27 0 01.22.32.27.27 0 01-.31.21zM89.06 139.45a.27.27 0 01-.25-.18.27.27 0 01.15-.35c4-1.54 9-.19 9.2-.13a.27.27 0 11-.14.52s-5-1.36-8.86.12z"
      transform="translate(-31.61 -1.63)"
    />
    <path
      className="cls-2"
      d="M93.57 136.57a.27.27 0 01-.26-.27v-4.78a.27.27 0 11.53 0v4.78a.27.27 0 01-.27.27zM97.51 133.79a.27.27 0 01-.26-.27v-3.68a.27.27 0 11.53 0v3.68a.27.27 0 01-.27.27zM90.18 134.18a.27.27 0 01-.27-.27v-4.58a.27.27 0 01.54 0v4.58a.27.27 0 01-.27.27z"
      transform="translate(-31.61 -1.63)"
    />
  </svg>
);

export const PriceEnterpriseIcon = () => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 96 96"
    xmlSpace="preserve"
  >
    <path
      class="st2"
      d="M48 42.5c-11.1 0-20.1-9-20.1-20.1S36.9 2.3 48 2.3s20.1 9 20.1 20.1-9 20.1-20.1 20.1zm0-39.8c-10.9 0-19.8 8.9-19.8 19.8S37.1 42.2 48 42.2s19.8-8.9 19.8-19.8S58.9 2.7 48 2.7z"
    ></path>
    <path
      class="st2"
      d="M47.7 38.1c-4.1-.1-8-1.8-10.9-4.7-2.9-3-4.5-6.9-4.5-11 0-8.7 7-15.7 15.7-15.7s15.7 7 15.7 15.7c0 8.4-6.6 15.3-15 15.7 0 0-.1 0-.1-.1 0 0 0-.1.1-.1 8.3-.4 14.8-7.2 14.8-15.5 0-8.6-7-15.5-15.5-15.5s-15.5 7-15.5 15.5c0 4.1 1.6 8 4.4 10.9 2.9 2.9 6.7 4.6 10.8 4.7 0 0 .1 0 0 .1z"
    ></path>
    <path
      class="st2"
      d="M47.6 35.9c-7.4-.2-13.1-6.1-13.1-13.5S40.6 8.9 48 8.9 61.5 15 61.5 22.4c0 7.1-5.6 13.1-12.7 13.5-.1 0-.2-.1-.2-.2s.1-.2.2-.2c6.9-.4 12.4-6.2 12.4-13.1 0-7.3-5.9-13.2-13.2-13.2s-13.2 5.9-13.2 13.2c0 7.2 5.6 13 12.8 13.2.1 0 .2.1.2.2 0 0-.1.1-.2.1z"
    ></path>
    <path
      class="st2"
      d="M47.7 33.6c-2.9-.1-5.7-1.3-7.7-3.4-2-2.1-3.2-4.9-3.2-7.8 0-6.2 5-11.2 11.2-11.2s11.2 5 11.2 11.2c0 5.9-4.6 10.8-10.4 11.2-.1 0-.1 0-.1-.1 0 0 0-.1.1-.1 5.7-.4 10.2-5.2 10.2-11 0-6.1-5-11-11-11s-11 5-11 11c0 2.9 1.1 5.6 3.1 7.7 2 2.1 4.7 3.3 7.6 3.3 0 .1.1.1 0 .2z"
    ></path>
    <path
      class="st2"
      d="M47.7 31.3c-4.8-.2-8.5-4.1-8.5-8.8 0-4.9 4-8.8 8.8-8.8s8.8 4 8.8 8.8c0 4.5-3.5 8.4-8.1 8.8-.1 0-.2-.1-.2-.2s.1-.2.2-.2c4.4-.4 7.8-4.1 7.8-8.5 0-4.7-3.8-8.5-8.5-8.5s-8.5 3.8-8.5 8.5c0 4.6 3.6 8.3 8.2 8.5.1 0 .2.1.2.2-.1.1-.1.2-.2.2z"
    ></path>
    <path
      class="st2"
      d="M47.7 29.5c-3.8-.2-6.8-3.3-6.8-7.1 0-3.9 3.2-7.1 7.1-7.1s7.1 3.2 7.1 7.1c0 3.7-2.7 6.7-6.4 7.1 0 0-.1 0-.1-.1 0 0 0-.1.1-.1 3.5-.4 6.2-3.3 6.2-6.9 0-3.8-3.1-6.9-6.9-6.9-3.8 0-6.9 3.1-6.9 6.9 0 3.7 2.9 6.8 6.6 6.9v.2z"
    ></path>
    <path
      class="st2"
      d="M48.7 28.9c-.1 0-.1-.1-.2-.1 0-.1 0-.2.1-.2 2-.4 3.5-3.8 3.3-6.3-.2-2.1-1.9-3.7-4-3.7-1.2 0-2.4.5-3.2 1.3-.6.7-.9 1.5-.9 2.4.2 3.3 1.4 5.3 3.8 6.3.1 0 .1.1.1.2s-.1.1-.2.1c-2.5-1.1-3.8-3.2-4-6.6-.1-1 .3-1.9 1-2.6.8-.9 2.1-1.4 3.4-1.4 2.3 0 4.2 1.7 4.4 4 .3 2.5-1.3 6.1-3.6 6.6.1 0 0 0 0 0z"
    ></path>
    <path
      class="st2"
      d="M48 24.7c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3zm0-4.2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    ></path>
    <path
      class="st2"
      d="M48 23.7c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3 1.3.6 1.3 1.3-.6 1.3-1.3 1.3zm0-2.2c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.5-1-1-1zM48.7 27.4h-.9c-.1 0-.2-.1-.2-.2v-1.8c0-.1.1-.2.2-.2h.9c.1 0 .2.1.2.2v1.8c-.1.1-.1.2-.2.2zm-.8-.4h.6v-1.5h-.6V27zM48.7 42.5h-.9c-.1 0-.2-.1-.2-.2V28.2c0-.1.1-.2.2-.2h.9c.1 0 .2.1.2.2v14.1c-.1.1-.1.2-.2.2zm-.8-.3h.6V28.4h-.6v13.8zM48.7 49.4h-.9c-.1 0-.2-.1-.2-.2v-6.1c0-.1.1-.2.2-.2h.9c.1 0 .2.1.2.2v6.1c-.1.1-.1.2-.2.2zm-.8-.4h.6v-5.7h-.6V49z"
    ></path>
    <path
      class="st2"
      d="M51.9 56.7c-.1 0-.2-.1-.2-.2l1.5-14.3-.6.9-.1.1h-8.6c-.1 0-.1 0-.1-.1l-.5-.8 1.4 14.1c0 .1-.1.2-.1.2-.1 0-.2-.1-.2-.1l-1.5-14.8c0-.1 0-.2.1-.2s.2 0 .2.1l.8 1.3h8.4l.9-1.4c0-.1.1-.1.2-.1s.1.1.1.2l-1.6 15c0 .1 0 .1-.1.1zM48.2 67.9c-1.6 0-2.9-1.2-2.9-2.6l-.6-5.7c0-.1.1-.2.1-.2.1 0 .2.1.2.1l.6 5.7c0 1.3 1.2 2.3 2.6 2.3 1.4 0 2.6-1 2.6-2.3l.6-5.7c0-.1.1-.2.2-.1.1 0 .2.1.1.2l-.6 5.7c0 1.4-1.3 2.6-2.9 2.6z"
    ></path>
    <path
      class="st2"
      d="M48.2 66.6c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9zm0-1.4c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5c.1-.3-.2-.5-.5-.5z"
    ></path>
    <path
      class="st2"
      d="M48.2 65.1s-.1-.1 0 0l-.1-15.9s0-.1.1-.1c0 0 .1 0 .1.1l-.1 15.9c.1-.1.1 0 0 0zM29.2 23.5c-.6 0-1-.5-1-1 0-.6.5-1 1-1 .6 0 1 .5 1 1s-.4 1-1 1zm0-1.7c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7zM66.8 23.5c-.6 0-1-.5-1-1 0-.6.5-1 1-1 .6 0 1 .5 1 1 .1.5-.4 1-1 1zm0-1.7c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7zM48.2 4.6c-.6 0-1-.5-1-1s.5-1 1-1c.6 0 1 .5 1 1s-.4 1-1 1zm0-1.7c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7z"
    ></path>
    <path
      class="st2"
      d="M48.2 18.5c-.1 0-.2-.1-.2-.2V4.4c0-.1.1-.2.2-.2s.2.1.2.2v13.9c0 .1-.1.2-.2.2zM49.1 18.7c-.1 0-.2-.1-.2-.2l4.2-15.3c0-.1.1-.1.2-.1s.1.1.1.2l-4.2 15.3c.1 0 0 .1-.1.1zM50.1 19c-.1 0-.1-.1-.1-.1l8-13.6s.1-.1.1 0c0 0 .1.1 0 .1l-8 13.6c.1 0 0 0 0 0zM51.1 19.8H51c-.1-.1-.1-.2 0-.2L62.1 8.3c.1-.1.2-.1.2 0 .1.1.1.2 0 .2L51.2 19.8h-.1zM51.7 20.6s-.1 0 0 0c-.1-.1-.1-.1 0-.2l13.6-8.1h.1v.1l-13.7 8.2zM52.2 21.8c-.1 0-.1 0-.2-.1 0-.1 0-.2.1-.2l15-4.3c.1 0 .2 0 .2.1s0 .2-.1.2l-15 4.3zM66 22.6H52.2c-.1 0-.2-.1-.2-.2s.1-.2.2-.2H66c.1 0 .2.1.2.2s-.1.2-.2.2zM67.2 27.8l-15.1-4c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l15 4c.1 0 .1.1.1.2.1 0 0 .1-.1.1zM65.3 32.5c-.1 0-.1 0 0 0l-13.1-7.7s-.1-.1 0-.1c0 0 .1-.1.1 0l13 7.7c0-.1.1 0 0 .1zM62.2 36.6h-.1L51.4 26c-.1-.1-.1-.2 0-.2.1-.1.2-.1.2 0l10.7 10.5c.1.1.1.2 0 .2 0 .1-.1.1-.1.1zM58.1 39.5l-7.4-12.3v-.1h.1l7.4 12.2c0 .1 0 .2-.1.2.1 0 .1 0 0 0zM53.5 41.7c-.1 0-.1 0-.2-.1l-3.7-13.4c0-.1 0-.2.1-.2s.2 0 .2.1l3.7 13.4c.1.1 0 .2-.1.2zM43 41.9c-.1 0-.2-.1-.2-.2l3.7-13.5c0-.1.1-.1.2-.1s.1.1.1.2l-3.7 13.5c.1 0 0 .1-.1.1zM47.2 18.5c-.1 0-.1 0-.2-.1L42.9 3.2c0-.1 0-.2.1-.2s.2 0 .2.1l4.1 15.2c0 .1 0 .2-.1.2zM46.1 18.8s-.1 0 0 0L38 5.2v-.1h.1l8 13.6c.1 0 .1.1 0 .1zM45.1 19.5H45L33.9 8.4c-.1-.1-.1-.2 0-.2.1-.1.2-.1.2 0l11.1 11.1c.1.1.1.2 0 .2h-.1zM44.3 20.4c-.1 0-.1 0 0 0l-13.5-7.9s-.1-.1 0-.1c0 0 .1-.1.1 0l13.5 7.8c-.1.1-.1.1-.1.2zM43.8 21.5l-15.1-4c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l15.1 4c.1 0 .1.1.1.2 0 0-.1.1-.2.1zM43.8 22.6H30.1c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h13.7c.1 0 .2.1.2.2-.1.1-.1.2-.2.2zM28.8 27.8c-.1 0-.1 0-.2-.1 0-.1 0-.2.1-.2l15.1-4c.1 0 .2 0 .2.1s0 .2-.1.2l-15.1 4zM30.7 32.5c-.1-.1-.1-.1 0-.2l13.5-7.5h.1v.1l-13.6 7.6c.1 0 .1 0 0 0zM34 36.7s-.1 0-.1-.1c-.1-.1-.1-.2 0-.2l10.9-10.3c.1-.1.2-.1.2 0 .1.1.1.2 0 .2L34.1 36.7H34zM38.2 39.9c-.1 0-.1-.1-.1-.1l7.5-12.6s.1-.1.1 0c0 0 .1.1 0 .1l-7.5 12.6c.1 0 .1 0 0 0zM45.4 59.7h-9.1c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h9.1c.3 0 .5-.2.5-.5v-1.6c0-.3-.2-.5-.5-.5h-9.9c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h9.9c.5 0 .9.4.9.9v1.6c0 .5-.4.9-.9.9z"
    ></path>
    <path
      class="st2"
      d="M35.4 68.5c-.1 0-.1 0-.2-.1 0-.1 0-.2.1-.2.5-.2.8-.8.8-1.7v-8c0-.2-.2-.4-.4-.4h-.2c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h.2c.4 0 .7.3.7.7v8c.1 1.2-.3 1.8-1 2.1z"
    ></path>
    <path
      class="st2"
      d="M36.3 67.2h-.9c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h.9c.1 0 .2.1.2.2s-.1.2-.2.2zM35.7 47.1h-5.1s-.1 0-.1-.1 0-.1.1-.1h5.1v.2zM35.6 49.1h-5s-.1 0-.1-.1c0 0 0-.1.1-.1h5c.1.1.1.1 0 .2.1 0 .1 0 0 0zM35.1 90.3h-3.8s-.1 0-.1-.1c0 0 0-.1.1-.1h3.8v.2z"
    ></path>
    <path
      class="st2"
      d="M33.2 93.7c-1.1 0-2-.9-2-2v-2.1H31c-.5 0-1-.4-1-1V81c0-.5.4-.9.9-1l-.5-33c0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7l-.5 32.9c.5 0 1 .4 1 1v7.6c0 .5-.4 1-1 1h-.2v2.2c.1 1.1-.8 2-1.9 2zM31 80.3c-.3 0-.6.3-.6.6v7.6c0 .3.3.6.6.6h.3c.1 0 .2.1.2.2v2.3c0 .9.8 1.7 1.7 1.7.9 0 1.7-.8 1.7-1.7v-2.3c0-.1.1-.2.2-.2h.3c.3 0 .6-.3.6-.6v-7.6c0-.3-.3-.6-.6-.6h-.2s-.1 0-.1-.1v-.1l.4-33.1c0-1.3-1.1-2.4-2.4-2.4s-2.4 1.1-2.4 2.4l.5 33.1v.1l-.1.1H31zM60.3 59.7h-9.1c-.5 0-.9-.4-.9-.9v-1.6c0-.5.4-.9.9-.9h9.9c.1 0 .2.1.2.2s-.1.2-.2.2h-9.9c-.3 0-.5.2-.5.5v1.6c0 .3.2.5.5.5h9.1c.1 0 .2.1.2.2s-.1.2-.2.2z"
    ></path>
    <path
      class="st2"
      d="M61.2 68.5c-.7-.3-1.1-1-1.1-2v-8c0-.4.3-.7.7-.7h.2c.1 0 .2.1.2.2s-.1.2-.2.2h-.2c-.2 0-.4.2-.4.4v8c0 .9.3 1.4.8 1.7.1 0 .1.1.1.2h-.1z"
    ></path>
    <path
      class="st2"
      d="M61.2 67.2h-.9c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h.9c.1 0 .2.1.2.2s-.1.2-.2.2zM66 47.1h-5.1s-.1 0-.1-.1 0-.1.1-.1H66c0 .1.1.1 0 .2.1 0 0 0 0 0zM66 49.1h-5s-.1 0-.1-.1c0 0 0-.1.1-.1h5c0 .1.1.1 0 .2.1 0 0 0 0 0zM65.3 90.3h-3.8s-.1 0-.1-.1c0 0 0-.1.1-.1h3.8c.1.1.1.1 0 .2.1 0 .1 0 0 0z"
    ></path>
    <path
      class="st2"
      d="M63.4 93.7c-1.1 0-2-.9-2-2v-2.1h-.2c-.5 0-1-.4-1-1V81c0-.5.4-1 1-1l-.4-33c0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7l-.5 32.9c.5 0 .9.5.9 1v7.6c0 .5-.4 1-1 1h-.1v2.2c0 1.1-1 2-2.1 2zm-2.2-13.4c-.3 0-.6.3-.6.6v7.6c0 .3.3.6.6.6h.3c.1 0 .2.1.2.2v2.3c0 .9.8 1.7 1.7 1.7s1.7-.8 1.7-1.7v-2.3c0-.1.1-.2.2-.2h.3c.3 0 .6-.3.6-.6v-7.6c0-.3-.3-.6-.6-.6h-.1s-.1 0-.1-.1v-.1l.4-33.1c0-1.3-1.1-2.4-2.4-2.4-1.3 0-2.4 1.1-2.4 2.4l.5 33.1v.1l-.1.1h-.2z"
    ></path>
    <g>
      <path
        class="st2"
        d="M31.3 89.4c-.1 0-.1 0 0 0l-.3-9.3s0-.1.1-.1c0 0 .1 0 .1.1l.1 9.3c.1 0 0 0 0 0z"
      ></path>
    </g>
    <g>
      <path
        class="st2"
        d="M35.1 89.6c-.1 0-.1-.1 0 0l.1-9.5s0-.1.1-.1c0 0 .1 0 .1.1l-.3 9.5c0-.1 0 0 0 0z"
      ></path>
    </g>
    <g>
      <path
        class="st2"
        d="M61.5 89.4l-.2-9.3s0-.1.1-.1c0 0 .1 0 .1.1v9.3c.1 0 .1 0 0 0z"
      ></path>
    </g>
    <g>
      <path
        class="st2"
        d="M65.3 89.4s-.1 0 0 0l.1-9.3s0-.1.1-.1c0 0 .1 0 .1.1l-.3 9.3c.1 0 .1 0 0 0z"
      ></path>
    </g>
    <g>
      <path
        class="st2"
        d="M31.7 73.4c-.1 0-.1-.1 0 0l-.1-2s0-.1.1-.1c0 0 .1 0 .1.1l-.1 2c.1-.1 0 0 0 0z"
      ></path>
    </g>
    <g>
      <path
        class="st2"
        d="M31.6 67.9s-.1 0 0 0l-.3-14.8s0-.1.1-.1.1 0 .1.1l.1 14.8c.1 0 .1 0 0 0z"
      ></path>
    </g>
    <g>
      <path
        class="st2"
        d="M64.7 73.4s0-.1 0 0l-.1-2s0-.1.1-.1c0 0 .1 0 .1.1l-.1 2c.1-.1.1 0 0 0z"
      ></path>
    </g>
    <g>
      <path
        class="st2"
        d="M64.8 67.9s-.1 0 0 0l.1-14.8s0-.1.1-.1c0 0 .1 0 .1.1l-.3 14.8c.1 0 .1 0 0 0z"
      ></path>
    </g>
  </svg>
);
